import React from "react";
import {
  ContentSection,
  FlexColumn,
  TextOnlyButton,
  FlexRow,
  LargeButton,
  LargeButtonSecondary,
  ButtonText,
  SlideUpModal,
  ModalOverlay,
  FormInputField,
  FloatingButton,
  Text,
  SwipeTabs,
  SwipeTab,
} from "../../../styles/Global";
import * as Global from "../../../styles/Global";
import moment from "moment";
import GridCustomEvents from "../../../components/GridCustomEvents";
import { AiFillCaretLeft } from "react-icons/ai";
import { ordinal_suffix_of } from "../../../functions/helperFunctions";
import { BiHandicap } from "react-icons/bi";
import DuprLightIcon from "../../../assets/icons/DuprLightIcon";
import BicepIcon from "../../../assets/icons/BicepIcon";
import HelipadIcon from "../../../assets/icons/HelipadIcon";

// Helper function to enhance column definitions with filtering and reordering capabilities
export const enhanceRankingsColumnDefs = (colDefs) => {
  return colDefs.map(colDef => {
    // Create a copy of the column definition
    const enhancedColDef = { ...colDef };

    // Add filter capability but preserve existing filter configuration
    // Only set filter to true if no specific filter is already defined
    if (!enhancedColDef.filter) {
      enhancedColDef.filter = true;
    }
    enhancedColDef.suppressMenu = true; // Hide filter icon in column headers

    // Ensure column headers show full text without ellipsis
    enhancedColDef.headerClass = "full-width-header";

    // Remove menu suppression if it exists
    // if (enhancedColDef.suppressMenu === true) {
    //   delete enhancedColDef.suppressMenu;
    // }

    // Allow column moving
    enhancedColDef.suppressMovable = false;

    return enhancedColDef;
  });
};

const sport = new URL(window.location.href).pathname.split("/")[2];

export const playerHistoryColDefs = [
  {
    headerName: "",
    sortingOrder: ["desc", "asc", null],
    field: "",
    minWidth: 30,
    maxWidth: 30,
    cellStyle: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    suppressMenu: true,
    cellRenderer: (data) => {
      return (
        <FlexColumn style={{ width: "100%" }} align="center" justify="center">
          {data.data.hasOwnProperty("smmatchId") &&
            data.data.smmatchId &&
            data.data.smmatchId !== "" && (
              <img
                alt="scoremagic bag"
                style={{ width: "20px" }}
                src={require(`../../../assets/${
                  data.data.bagId !== "" ? "bag-yes.png" : "bag-no.png"
                }`)}
              />
            )}
            {
              sport === 'pickleball' && data.data?.thirdPartyId && data.data?.thirdPartyId !== '' &&
              <DuprLightIcon color={Global.blueLight} width="21px" height="15px" />

            }
          {data.data?.handicapEnabled === true && (
            // <BiHandicap size={14} color={Global.redLight} />
            // <BicepIcon color={Global.redLight} width='13px' height='13px'/>
            <HelipadIcon color={Global.redLight} width="14px" height="14px" />
          )}
        </FlexColumn>
      );
    },
  },
  {
    headerName: "Date",
    sortingOrder: ["desc", "asc", null],
    field: "timestamp",
    minWidth: 90,
    maxWidth: 90,
    sortable: true,
    suppressMenu: true,
    suppressSizeToFit: false,
    cellRenderer: (data) => {
      return (
        <div
          dangerouslySetInnerHTML={{
            __html: moment(data.value, "X").format("MMM DD, YYYY[<br/>] h:mma"),
          }}
        ></div>
      );
    },
  },
  {
    headerName: "Matchup",
    sortingOrder: ["desc", "asc", null],
    field: "teamName",
    // minWidth: 135,
    // maxWidth: 400,
    flex: 1,
    suppressMenu: true,
    suppressSizeToFit: false,
    cellRenderer: (data) => {
      // console.log("data.data: ", data.data);
      const win = data.data.teamScore > data.data.opponentScore;
      const tie = data.data.teamScore === data.data.opponentScore;
      return (
        <FlexColumn style={{ flex: 1, width: "100%" }}>
          <Text
            size="1em"
            color={data.data.status === "Deleted" && "#b4b4b4"}
            style={{
              width: "100%",
              whiteSpace: "nowrap",
              textOverflow: "ellipsis",
              // borderBottom: "1px solid #efefef",
              fontWeight: win && !tie && "900",
              overflow: "hidden",
            }}
          >
            {/* For some stupid reason, two spaces are causing problems on older devices */}
            {data.data.teamName.replace("  ", " ")}
          </Text>
          <Text
            size="1em"
            color={data.data.status === "Deleted" && "#b4b4b4"}
            style={{
              width: "100%",
              whiteSpace: "nowrap",
              textOverflow: "ellipsis",
              fontWeight: !win && !tie && "900",
              overflow: "hidden",
            }}
          >
            {/* For some stupid reason, two spaces are causing problems on older devices */}
            {data.data.opponentTeamName.replace("  ", " ")}
          </Text>
        </FlexColumn>
      );
    },
  },
  {
    headerName: "Score",
    sortingOrder: ["desc", "asc", null],
    field: "score",
    suppressMenu: true,
    minWidth: 50,
    maxWidth: 50,
    suppressSizeToFit: false,
    cellRenderer: (data) => {
      const win = data.data.teamScore > data.data.opponentScore;
      const tie = data.data.teamScore === data.data.opponentScore;
      return (
        <FlexColumn align="flex-end">
          <Text
            size="1em"
            color={data.data.status === "Deleted" && "#b4b4b4"}
            style={{
              // width: "100%",
              whiteSpace: "nowrap",
              textOverflow: "ellipsis",
              // borderBottom: "1px solid #efefef",
              fontWeight: win && !tie && "900",
              alignItems: "center",
              alignContent: "center",
            }}
          >
            {data.data.teamScore}
          </Text>
          <Text
            size="1em"
            color={data.data.status === "Deleted" && "#b4b4b4"}
            style={{
              whiteSpace: "nowrap",
              textOverflow: "ellipsis",
              fontWeight: !win && !tie && "900",
            }}
          >
            {data.data.opponentScore}
          </Text>
        </FlexColumn>
      );
    },
  },
  {
    headerName: "+/-",
    sortingOrder: ["desc", "asc", null],
    field: "changeRanking",
    minWidth: 50,
    maxWidth: 50,
    suppressMenu: true,
    suppressSizeToFit: false,
    hide: sport === "pickleball",
    cellRenderer: (data) => {
      if (parseFloat(data.value) < 0) {
        // console.log("columnDef data: ", data);
        // console.log(
        //   "columnDef data.data.status: ",
        //   data.data.status
        // );
        return (
          <div
            style={{
              color: data.data.status === "Deleted" ? "#b4b4b4" : "red",
              textDecoration: data.data.status === "Deleted" && "line-through",
            }}
          >
            {Number(data.value).toFixed(2)}
          </div>
        );
      } else if (parseFloat(data.value) > 0) {
        return (
          <div
            style={{
              color: data.data.status === "Deleted" ? "#b4b4b4" : "#0F9C48",
              textDecoration: data.data.status === "Deleted" && "line-through",
            }}
          >
            +{Number(data.value).toFixed(2)}
          </div>
        );
      } else {
        return Number(data.value).toFixed(2);
      }
    },
  },
];
export const playerHistoryGroupColDefs = [
  {
    headerName: "Date",
    sortingOrder: ["desc", "asc", null],
    field: "tournamentDate",
    minWidth: 130,
    maxWidth: 130,
    sortable: true,
    sort: "desc",
    suppressMenu: true,
    cellRenderer: "agGroupCellRenderer",
    cellRendererParams: {
      innerRenderer: (data) => {
        return (
          <div
            dangerouslySetInnerHTML={{
              __html: moment(data.value, "X").format(
                "MMM DD, YYYY[<br/>] h:mma"
              ),
            }}
          ></div>
        );
      },
    },
  },
  {
    headerName: "Tournament Name",
    sortingOrder: ["desc", "asc", null],
    colId: "tournamentName",
    field: "tournamentName",
    // minWidth: 170,
    // maxWidth: 400,
    flex: 1,
    sortable: true,
    suppressMenu: true,
    filterParams: {
      applyMiniFilterWhileTyping: true,
    },
    filter: "agSetColumnFilter",
    hide: false,
    cellRenderer: (params) => {
      return (
        <div
          dangerouslySetInnerHTML={{
            __html:
              "<strong>" +
              params.value +
              "</strong><br />" +
              params.data.clubName,
          }}
        ></div>
      );
    },
  },
  {
    headerName: "Club Name",
    sortingOrder: ["desc", "asc", null],
    colId: "clubName",
    field: "clubName",
    minWidth: 110,
    maxWidth: 120,
    sortable: true,
    suppressMenu: true,
    filterParams: {
      applyMiniFilterWhileTyping: true,
    },
    filter: "agSetColumnFilter",
    hide: true,
  },
  {
    headerName: "#",
    sortingOrder: ["desc", "asc", null],
    colId: "matchCount",
    field: "matchCount",
    minWidth: 35,
    maxWidth: 35,
    sortable: true,
    suppressMenu: true,
    filterParams: {
      applyMiniFilterWhileTyping: true,
    },
    filter: "agSetColumnFilter",
    hide: false,
  },
];
export const trophyRoomPlacementColDefs = [
  {
    headerName: "Place",
    sortingOrder: ["asc", "desc", null],
    colId: "placeLabel",
    field: "placeLabel",
    sort: "asc",
    comparator: function (valueA, valueB, nodeA, nodeB, isDescending) {
      const nodeAValue = nodeA.data
        ? nodeA.data["place"]
        : nodeA.allLeafChildren[0].data["place"];
      const nodeBValue = nodeB.data
        ? nodeB.data["place"]
        : nodeB.allLeafChildren[0].data["place"];
      return nodeAValue > nodeBValue ? 1 : -1;
    },
    minWidth: 65,
    maxWidth: 65,
    sortable: true,
    suppressMenu: true,
    rowGroup: true,
    // hide: true,
    filterParams: {
      applyMiniFilterWhileTyping: true,
    },
    filter: "agSetColumnFilter",
    // hide: true,
    // cellRenderer: (params) => {
    //   return params.data.placeLabel;
    // },
  },
  {
    headerName: "Tournament Name",
    sortingOrder: ["desc", "asc", null],
    colId: "gameName",
    field: "gameName",
    // minWidth: 170,
    // maxWidth: 400,
    flex: 1,
    sortable: true,
    suppressMenu: true,
    filterParams: {
      applyMiniFilterWhileTyping: true,
    },
    filter: "agSetColumnFilter",
    hide: false,
    cellRenderer: (params) => {
      return (
        <div
          dangerouslySetInnerHTML={{
            __html:
              "<strong>" +
              params.value +
              "</strong><br />" +
              params.data.teamName,
          }}
        ></div>
      );
    },
  },
  {
    headerName: "Seed",
    sortingOrder: ["desc", "asc", null],
    colId: "seed",
    field: "seed",
    minWidth: 40,
    maxWidth: 40,
    sortable: true,
    suppressMenu: true,
    filterParams: {
      applyMiniFilterWhileTyping: true,
    },
    filter: "agSetColumnFilter",
    hide: false,
  },
  {
    headerName: "W",
    sortingOrder: ["desc", "asc", null],
    colId: "wins",
    field: "wins",
    minWidth: 30,
    maxWidth: 30,
    sortable: true,
    suppressMenu: true,
    filterParams: {
      applyMiniFilterWhileTyping: true,
    },
    filter: "agSetColumnFilter",
    hide: false,
    cellStyle: {
      textAlign: "center",
    },
  },
  {
    headerName: "L",
    sortingOrder: ["desc", "asc", null],
    colId: "losses",
    field: "losses",
    minWidth: 30,
    maxWidth: 30,
    sortable: true,
    suppressMenu: true,
    filterParams: {
      applyMiniFilterWhileTyping: true,
    },
    filter: "agSetColumnFilter",
    hide: false,
    cellStyle: {
      textAlign: "center",
    },
  },
  {
    headerName: "",
    colId: "teamCreate",
    field: "teamCreate",
    sortable: true,
    filterParams: {
      applyMiniFilterWhileTyping: true,
    },
    filter: "agSetColumnFilter",
    hide: true,
  },
  {
    headerName: "",
    colId: "bracketSize",
    field: "bracketSize",
    sortable: true,
    filterParams: {
      applyMiniFilterWhileTyping: true,
    },
    filter: "agSetColumnFilter",
    hide: true,
  },
  {
    headerName: "",
    colId: "bracketSizeTotal",
    field: "bracketSizeTotal",
    sortable: true,
    filterParams: {
      applyMiniFilterWhileTyping: true,
    },
    filter: "agSetColumnFilter",
    hide: true,
  },
  {
    headerName: "",
    colId: "club",
    field: "club",
    sortable: true,
    filterParams: {
      applyMiniFilterWhileTyping: true,
    },
    filter: "agSetColumnFilter",
    hide: true,
  },
];
export const practiceHistoryColDefs = [
  {
    headerName: "Date",
    sortingOrder: ["desc", "asc", null],
    colId: "createDate",
    field: "createDate",
    minWidth: 90,
    maxWidth: 90,
    sortable: true,
    suppressMenu: true,
    filterParams: {
      applyMiniFilterWhileTyping: true,
    },
    filter: "agSetColumnFilter",
    cellRenderer: (data) => {
      return (
        <div
          dangerouslySetInnerHTML={{
            __html: moment(data.value, "X").format("MMM DD, YYYY[<br/>] h:mma"),
          }}
        ></div>
      );
    },
  },
  {
    headerName: "Opponent",
    sortingOrder: ["desc", "asc", null],
    colId: "oppTeamName",
    field: "oppTeamName",
    minWidth: 10,
    // maxWidth: 200,
    sortable: true,
    suppressMenu: true,
    filterParams: {
      applyMiniFilterWhileTyping: true,
    },
    filter: "agSetColumnFilter",
  },
  {
    headerName: "Team",
    sortingOrder: ["desc", "asc", null],
    colId: "teamName",
    field: "teamName",
    minWidth: 10,
    // maxWidth: 200,
    sortable: true,
    suppressMenu: true,
    filterParams: {
      applyMiniFilterWhileTyping: true,
    },
    filter: "agSetColumnFilter",
    hide: true,
  },
  {
    headerName: "Score",
    sortingOrder: ["desc", "asc", null],
    colId: "formattedScore",
    field: "formattedScore",
    sortable: true,
    suppressMenu: true,
    filterParams: {
      applyMiniFilterWhileTyping: true,
    },
    filter: "agSetColumnFilter",
    minWidth: 80,
    maxWidth: 80,
  },
  {
    headerName: "Match Type",
    sortingOrder: ["desc", "asc", null],
    colId: "matchType",
    field: "matchType",
    sortable: true,
    suppressMenu: true,
    filterParams: {
      applyMiniFilterWhileTyping: true,
    },
    minWidth: 50,
    filter: "agSetColumnFilter",
    maxWidth: 50,
    hide: true,
  },
  {
    headerName: "Outcome",
    sortingOrder: ["desc", "asc", null],
    colId: "outcome",
    field: "outcome",
    sortable: true,
    suppressMenu: true,
    filterParams: {
      applyMiniFilterWhileTyping: true,
    },
    minWidth: 50,
    filter: "agSetColumnFilter",
    maxWidth: 50,
    hide: true,
  },
  {
    headerName: "Bag ID",
    sortingOrder: ["desc", "asc", null],
    colId: "teamBagId",
    field: "teamBagId",
    sortable: true,
    suppressMenu: true,
    filterParams: {
      applyMiniFilterWhileTyping: true,
    },
    minWidth: 50,
    filter: "agSetColumnFilter",
    maxWidth: 50,
    hide: true,
  },
  {
    headerName: "Tag",
    sortingOrder: ["desc", "asc", null],
    colId: "teamTagsStr",
    field: "teamTagsStr",
    sortable: true,
    suppressMenu: true,
    // filterParams: {
    //   applyMiniFilterWhileTyping: true,
    // },
    minWidth: 50,
    filter: "agMultiColumnFilter",
    //filterType: "multi",

    maxWidth: 50,
    hide: true,
  },
];

export const rankingsGlobalColDefs = enhanceRankingsColumnDefs([
  {
    headerName: "#",
    sortingOrder: ["desc", "asc", null],
    field: "_source.globalRank",
    minWidth: 50,
    maxWidth: 70,
    wrapText: false,
    suppressMenu: true,
    sortable: true,
  },
  {
    headerName: "Name",
    sortingOrder: ["desc", "asc", null],
    field: "_source.displayName",
    minWidth: 90,
    sortable: true,
    wrapText: true,
    suppressMenu: true,
    filter: "agTextColumnFilter",
    filterParams: {
      debounceMs: 200,
      suppressAndOrCondition: true,
      filterOptions: ["contains"],
    },
  },
  {
    headerName: "Club",
    sortingOrder: ["desc", "asc", null],
    field: "_source.clubName",
    minWidth: 90,
    sortable: true,
    wrapText: true,
    suppressMenu: true,
    filter: "agTextColumnFilter",
    filterParams: {
      debounceMs: 200,
      suppressAndOrCondition: true,
      filterOptions: ["contains"],
    },
  },
  {
    headerName: "ST",
    sortingOrder: ["desc", "asc", null],
    field: "_source.state",
    minWidth: 35,
    maxWidth: 35,
    wrapText: false,
    sortable: true,
    suppressMenu: true,
    filter: "agTextColumnFilter",
    filterParams: {
      debounceMs: 200,
      suppressAndOrCondition: true,
      filterOptions: ["contains"],
    },
  },
  {
    headerName: "SPR",
    sortingOrder: ["desc", "asc", null],
    field: "_source.currentRanking",
    minWidth: 45,
    maxWidth: 65,
    wrapText: false,
    suppressMenu: true,
    cellRenderer: (data) => {
      return Number(data.value).toFixed(2);
    },
    sortable: true,
    hide: sport === "pickleball",
  },
  {
    headerName: "DUPR SINGLES",
    sortingOrder: ["desc", "asc", null],
    field: "_source.duprSingles",
    minWidth: 65,
    maxWidth: 65,
    wrapText: false,
    suppressMenu: true,
    cellRenderer: (data) => {
      return Number(data.value).toFixed(2);
    },
    sortable: true,
    hide: sport !== "pickleball",
  },
  {
    headerName: "DUPR DOUBLES",
    sortingOrder: ["desc", "asc", null],
    field: "_source.duprDoubles",
    minWidth: 75,
    maxWidth: 75,
    wrapText: false,
    suppressMenu: true,
    cellRenderer: (data) => {
      return Number(data.value).toFixed(2);
    },
    sortable: true,
    hide: sport !== "pickleball",
  },
  {
    headerName: "WIN%",
    sortingOrder: ["desc", "asc", null],
    field: "",
    minWidth: 50,
    maxWidth: 50,
    wrapText: false,
    suppressMenu: true,
    cellRenderer: (data) => {
      return `${Math.round(
        (data.data._source.totalWins * 100) / data.data._source.totalMatches
      )}%`;
    },
    sortable: false,
  },
  {
    headerName: "WINS",
    sortingOrder: ["desc", "asc", null],
    field: "_source.totalWins",
    minWidth: 50,
    maxWidth: 70,
    wrapText: false,
    suppressMenu: true,
    sortable: true,
  },
  {
    headerName: "MATCHES",
    sortingOrder: ["desc", "asc", null],
    field: "_source.totalMatches",
    minWidth: 70,
    maxWidth: 70,
    wrapText: false,
    suppressMenu: true,
    sortable: true,
  },
]);
export const rankingsGlobalPprColDefs = enhanceRankingsColumnDefs([
  {
    headerName: "#",
    sortingOrder: ["desc", "asc", null],
    field: "_source.globalRank",
    minWidth: 50,
    maxWidth: 70,
    pinned: "left",
    wrapText: false,
    suppressMenu: true,
    sortable: true,
  },
  {
    headerName: "Name",
    sortingOrder: ["desc", "asc", null],
    field: "_source.displayName",
    minWidth: 90,
    sortable: true,
    wrapText: true,
    suppressMenu: true,
    pinned: "left",
    filter: "agTextColumnFilter",
    filterParams: {
      debounceMs: 200,
      suppressAndOrCondition: true,
      filterOptions: ["contains"],
    },
  },
  {
    headerName: "Club",
    sortingOrder: ["desc", "asc", null],
    field: "_source.clubName",
    minWidth: 90,
    sortable: true,
    wrapText: true,
    suppressMenu: true,
    filter: "agTextColumnFilter",
    filterParams: {
      debounceMs: 200,
      suppressAndOrCondition: true,
      filterOptions: ["contains"],
    },
  },
  {
    headerName: "ST",
    sortingOrder: ["desc", "asc", null],
    field: "_source.state",
    minWidth: 35,
    maxWidth: 35,
    wrapText: false,
    sortable: true,
    suppressMenu: true,
    filter: "agTextColumnFilter",
    filterParams: {
      debounceMs: 200,
      suppressAndOrCondition: true,
      filterOptions: ["contains"],
    },
  },
  {
    headerName: "SPR",
    sortingOrder: ["desc", "asc", null],
    field: "_source.currentRanking",
    minWidth: 50,
    maxWidth: 65,
    wrapText: false,
    suppressMenu: true,
    cellRenderer: (data) => {
      return Number(data.value).toFixed(2);
    },
    sortable: true,
    hide: sport === "pickleball",
  },
  {
    headerName: "DUPR SINGLES",
    sortingOrder: ["desc", "asc", null],
    field: "_source.duprSingles",
    minWidth: 65,
    maxWidth: 65,
    wrapText: false,
    suppressMenu: true,
    cellRenderer: (data) => {
      return Number(data.value).toFixed(2);
    },
    sortable: true,
    hide: sport !== "pickleball",
  },
  {
    headerName: "DUPR DOUBLES",
    sortingOrder: ["desc", "asc", null],
    field: "_source.duprDoubles",
    minWidth: 75,
    maxWidth: 75,
    wrapText: false,
    suppressMenu: true,
    cellRenderer: (data) => {
      return Number(data.value).toFixed(2);
    },
    sortable: true,
    hide: sport !== "pickleball",
  },
  {
    headerName: "PPR",
    sortingOrder: ["desc", "asc", null],
    field: "_source.ppr",
    minWidth: 45,
    maxWidth: 60,
    wrapText: false,
    suppressMenu: true,
    cellRenderer: (data) => {
      if (data.value) {
        return Number(data.value).toFixed(2);
      } else {
        return null;
      }
    },
    sortable: true,
  },
  {
    headerName: "DPR",
    sortingOrder: ["desc", "asc", null],
    field: "_source.dpr",
    minWidth: 45,
    maxWidth: 60,
    wrapText: false,
    suppressMenu: true,
    cellRenderer: (data) => {
      if (data.value) {
        return Number(data.value).toFixed(2);
      } else {
        return null;
      }
    },
    sortable: true,
  },
  {
    headerName: "OPPR",
    sortingOrder: ["desc", "asc", null],
    field: "_source.oppr",
    minWidth: 45,
    maxWidth: 60,
    wrapText: false,
    suppressMenu: true,
    cellRenderer: (data) => {
      if (data.value) {
        return Number(data.value).toFixed(2);
      } else {
        return null;
      }
    },
    sortable: true,
  },
  {
    headerName: "SBD",
    sortingOrder: ["desc", "asc", null],
    field: "_source.matchTypeDiff",
    minWidth: 50,
    maxWidth: 50,
    wrapText: false,
    suppressMenu: true,
    sortable: true,
  },
  {
    headerName: "SB%",
    sortingOrder: ["desc", "asc", null],
    field: "_source.matchTypeDiffPercent",
    minWidth: 50,
    maxWidth: 50,
    wrapText: false,
    suppressMenu: true,
    cellRenderer: (data) => {
      // console.log("SB% data: ", data);
      return data.value !== null && data.value !== undefined
        ? `${data.value}%`
        : "";
    },
    sortable: true,
  },
  {
    headerName: "WIN%",
    sortingOrder: ["desc", "asc", null],
    field: "",
    minWidth: 50,
    maxWidth: 50,
    wrapText: false,
    suppressMenu: true,
    cellRenderer: (data) => {
      return `${Math.round(
        (data.data._source.totalWins * 100) / data.data._source.totalMatches
      )}%`;
    },
    sortable: false,
  },
  {
    headerName: "WINS",
    sortingOrder: ["desc", "asc", null],
    field: "_source.totalWins",
    minWidth: 50,
    maxWidth: 70,
    wrapText: false,
    suppressMenu: true,
    sortable: true,
  },
  {
    headerName: "MATCHES",
    sortingOrder: ["desc", "asc", null],
    field: "_source.totalMatches",
    minWidth: 70,
    maxWidth: 70,
    wrapText: false,
    suppressMenu: true,
    sortable: true,
  },
  {
    headerName: "4IN%",
    sortingOrder: ["desc", "asc", null],
    field: "_source.totalfourinpercent",
    minWidth: 45,
    maxWidth: 60,
    wrapText: false,
    suppressMenu: true,
    sortable: true,
  },
  {
    headerName: "IN%",
    sortingOrder: ["desc", "asc", null],
    field: "_source.totalinpercent",
    minWidth: 45,
    maxWidth: 60,
    wrapText: false,
    suppressMenu: true,
    sortable: true,
  },
  {
    headerName: "ON%",
    sortingOrder: ["desc", "asc", null],
    field: "_source.totalonpercent",
    minWidth: 45,
    maxWidth: 60,
    wrapText: false,
    suppressMenu: true,
    sortable: true,
  },
  {
    headerName: "OFF%",
    sortingOrder: ["desc", "asc", null],
    field: "_source.totaloffpercent",
    minWidth: 50,
    maxWidth: 60,
    wrapText: false,
    suppressMenu: true,
    sortable: true,
  },
  {
    headerName: "RND",
    sortingOrder: ["desc", "asc", null],
    field: "_source.totalrounds",
    minWidth: 45,
    maxWidth: 60,
    wrapText: false,
    suppressMenu: true,
    sortable: true,
  },

  {
    headerName: "RW%",
    sortingOrder: ["desc", "asc", null],
    field: "_source.roundwinpercent",
    minWidth: 45,
    maxWidth: 60,
    wrapText: false,
    suppressMenu: true,
    sortable: true,
  },
  {
    headerName: "RL%",
    sortingOrder: ["desc", "asc", null],
    field: "_source.roundlosspercent",
    minWidth: 45,
    maxWidth: 60,
    wrapText: false,
    suppressMenu: true,
    sortable: true,
  },
  {
    headerName: "RT%",
    sortingOrder: ["desc", "asc", null],
    field: "_source.roundtiepercent",
    minWidth: 45,
    maxWidth: 60,
    wrapText: false,
    suppressMenu: true,
    sortable: true,
  },
]);
export const rankingsGlobalHorseshoesPprColDefs = enhanceRankingsColumnDefs([
  {
    headerName: "#",
    sortingOrder: ["desc", "asc", null],
    field: "_source.globalRank",
    minWidth: 50,
    maxWidth: 70,
    pinned: "left",
    wrapText: false,
    suppressMenu: true,
    sortable: true,
  },
  {
    headerName: "Name",
    sortingOrder: ["desc", "asc", null],
    field: "_source.displayName",
    minWidth: 90,
    sortable: true,
    wrapText: true,
    suppressMenu: true,
    pinned: "left",
    filter: "agTextColumnFilter",
    filterParams: {
      debounceMs: 200,
      suppressAndOrCondition: true,
      filterOptions: ["contains"],
    },
  },
  {
    headerName: "Club",
    sortingOrder: ["desc", "asc", null],
    field: "_source.clubName",
    minWidth: 90,
    sortable: true,
    wrapText: true,
    suppressMenu: true,
    filter: "agTextColumnFilter",
    filterParams: {
      debounceMs: 200,
      suppressAndOrCondition: true,
      filterOptions: ["contains"],
    },
  },
  {
    headerName: "ST",
    sortingOrder: ["desc", "asc", null],
    field: "_source.state",
    minWidth: 35,
    maxWidth: 35,
    wrapText: false,
    sortable: true,
    suppressMenu: true,
    filter: "agTextColumnFilter",
    filterParams: {
      debounceMs: 200,
      suppressAndOrCondition: true,
      filterOptions: ["contains"],
    },
  },
  {
    headerName: "SPR",
    sortingOrder: ["desc", "asc", null],
    field: "_source.currentRanking",
    minWidth: 50,
    maxWidth: 65,
    wrapText: false,
    suppressMenu: true,
    cellRenderer: (data) => {
      return Number(data.value).toFixed(2);
    },
    sortable: true,
    hide: sport === "pickleball",
  },
  {
    headerName: "DUPR SINGLES",
    sortingOrder: ["desc", "asc", null],
    field: "_source.duprSingles",
    minWidth: 65,
    maxWidth: 65,
    wrapText: false,
    suppressMenu: true,
    cellRenderer: (data) => {
      return Number(data.value).toFixed(2);
    },
    sortable: true,
    hide: sport !== "pickleball",
  },
  {
    headerName: "DUPR DOUBLES",
    sortingOrder: ["desc", "asc", null],
    field: "_source.duprDoubles",
    minWidth: 75,
    maxWidth: 75,
    wrapText: false,
    suppressMenu: true,
    cellRenderer: (data) => {
      return Number(data.value).toFixed(2);
    },
    sortable: true,
    hide: sport !== "pickleball",
  },
  {
    headerName: "PPR",
    sortingOrder: ["desc", "asc", null],
    field: "_source.ppr",
    minWidth: 45,
    maxWidth: 60,
    wrapText: false,
    suppressMenu: true,
    cellRenderer: (data) => {
      if (data.value) {
        return Number(data.value).toFixed(2);
      } else {
        return null;
      }
    },
    sortable: true,
  },
  {
    headerName: "DPR",
    sortingOrder: ["desc", "asc", null],
    field: "_source.dpr",
    minWidth: 45,
    maxWidth: 60,
    wrapText: false,
    suppressMenu: true,
    cellRenderer: (data) => {
      if (data.value) {
        return Number(data.value).toFixed(2);
      } else {
        return null;
      }
    },
    sortable: true,
  },
  {
    headerName: "OPPR",
    sortingOrder: ["desc", "asc", null],
    field: "_source.oppr",
    minWidth: 45,
    maxWidth: 60,
    wrapText: false,
    suppressMenu: true,
    cellRenderer: (data) => {
      if (data.value) {
        return Number(data.value).toFixed(2);
      } else {
        return null;
      }
    },
    sortable: true,
  },
  {
    headerName: "SBD",
    sortingOrder: ["desc", "asc", null],
    field: "_source.matchTypeDiff",
    minWidth: 50,
    maxWidth: 50,
    wrapText: false,
    suppressMenu: true,
    sortable: true,
  },
  {
    headerName: "SB%",
    sortingOrder: ["desc", "asc", null],
    field: "_source.matchTypeDiffPercent",
    minWidth: 50,
    maxWidth: 50,
    wrapText: false,
    suppressMenu: true,
    cellRenderer: (data) => {
      // console.log("SB% data: ", data);
      return data.value !== null && data.value !== undefined
        ? `${data.value}%`
        : "";
    },
    sortable: true,
  },
  {
    headerName: "WIN%",
    sortingOrder: ["desc", "asc", null],
    field: "",
    minWidth: 50,
    maxWidth: 50,
    wrapText: false,
    suppressMenu: true,
    cellRenderer: (data) => {
      return `${Math.round(
        (data.data._source.totalWins * 100) / data.data._source.totalMatches
      )}%`;
    },
    sortable: false,
  },
  {
    headerName: "WINS",
    sortingOrder: ["desc", "asc", null],
    field: "_source.totalWins",
    minWidth: 50,
    maxWidth: 70,
    wrapText: false,
    suppressMenu: true,
    sortable: true,
  },
  {
    headerName: "MATCHES",
    sortingOrder: ["desc", "asc", null],
    field: "_source.totalMatches",
    minWidth: 70,
    maxWidth: 70,
    wrapText: false,
    suppressMenu: true,
    sortable: true,
  },
  {
    headerName: "2-R%",
    sortingOrder: ["desc", "asc", null],
    field: "_source.totalring2percent",
    minWidth: 45,
    maxWidth: 60,
    wrapText: false,
    suppressMenu: true,
    sortable: true,
  },
  {
    headerName: "1-R%",
    sortingOrder: ["desc", "asc", null],
    field: "_source.totalring1percent",
    minWidth: 45,
    maxWidth: 60,
    wrapText: false,
    suppressMenu: true,
    sortable: true,
  },
  {
    headerName: "0-R%",
    sortingOrder: ["desc", "asc", null],
    field: "_source.totalring0percent",
    minWidth: 45,
    maxWidth: 60,
    wrapText: false,
    suppressMenu: true,
    sortable: true,
  },
  {
    headerName: "TR%",
    sortingOrder: ["desc", "asc", null],
    field: "_source.totalallinpercent",
    minWidth: 50,
    maxWidth: 60,
    wrapText: false,
    suppressMenu: true,
    sortable: true,
  },
  {
    headerName: "MISS%",
    sortingOrder: ["desc", "asc", null],
    field: "_source.totaloffpercent",
    minWidth: 50,
    maxWidth: 60,
    wrapText: false,
    suppressMenu: true,
    sortable: true,
  },
  {
    headerName: "RND",
    sortingOrder: ["desc", "asc", null],
    field: "_source.totalrounds",
    minWidth: 45,
    maxWidth: 60,
    wrapText: false,
    suppressMenu: true,
    sortable: true,
  },

  {
    headerName: "RW%",
    sortingOrder: ["desc", "asc", null],
    field: "_source.roundwinpercent",
    minWidth: 45,
    maxWidth: 60,
    wrapText: false,
    suppressMenu: true,
    sortable: true,
  },
  {
    headerName: "RL%",
    sortingOrder: ["desc", "asc", null],
    field: "_source.roundlosspercent",
    minWidth: 45,
    maxWidth: 60,
    wrapText: false,
    suppressMenu: true,
    sortable: true,
  },
  {
    headerName: "RT%",
    sortingOrder: ["desc", "asc", null],
    field: "_source.roundtiepercent",
    minWidth: 45,
    maxWidth: 60,
    wrapText: false,
    suppressMenu: true,
    sortable: true,
  },
]);
export const rankingsStateColDefs = enhanceRankingsColumnDefs([
  {
    headerName: "#",
    sortingOrder: ["desc", "asc", null],
    field: "_source.stateRank",
    minWidth: 50,
    maxWidth: 70,
    wrapText: false,
    suppressMenu: true,
    sortable: true,
  },
  {
    headerName: "Name",
    sortingOrder: ["desc", "asc", null],
    field: "_source.displayName",
    minWidth: 90,
    sortable: true,
    wrapText: true,
    suppressMenu: true,
    filter: "agTextColumnFilter",
    filterParams: {
      debounceMs: 200,
      suppressAndOrCondition: true,
      filterOptions: ["contains"],
    },
  },
  {
    headerName: "Club",
    sortingOrder: ["desc", "asc", null],
    field: "_source.clubName",
    minWidth: 90,
    sortable: true,
    wrapText: true,
    suppressMenu: true,
    filter: "agTextColumnFilter",
    filterParams: {
      debounceMs: 200,
      suppressAndOrCondition: true,
      filterOptions: ["contains"],
    },
  },
  {
    headerName: "ST",
    sortingOrder: ["desc", "asc", null],
    field: "_source.state",
    minWidth: 35,
    maxWidth: 35,
    wrapText: false,
    sortable: true,
    suppressMenu: true,
    filter: "agTextColumnFilter",
    filterParams: {
      debounceMs: 200,
      suppressAndOrCondition: true,
      filterOptions: ["contains"],
    },
  },
  {
    headerName: "SPR",
    sortingOrder: ["desc", "asc", null],
    field: "_source.currentRanking",
    minWidth: 45,
    maxWidth: 65,
    wrapText: false,
    suppressMenu: true,
    cellRenderer: (data) => {
      return Number(data.value).toFixed(2);
    },
    sortable: true,
    hide: sport === "pickleball",
  },
  {
    headerName: "DUPR SINGLES",
    sortingOrder: ["desc", "asc", null],
    field: "_source.duprSingles",
    minWidth: 65,
    maxWidth: 65,
    wrapText: false,
    suppressMenu: true,
    cellRenderer: (data) => {
      return Number(data.value).toFixed(2);
    },
    sortable: true,
    hide: sport !== "pickleball",
  },
  {
    headerName: "DUPR DOUBLES",
    sortingOrder: ["desc", "asc", null],
    field: "_source.duprDoubles",
    minWidth: 75,
    maxWidth: 75,
    wrapText: false,
    suppressMenu: true,
    cellRenderer: (data) => {
      return Number(data.value).toFixed(2);
    },
    sortable: true,
    hide: sport !== "pickleball",
  },
  {
    headerName: "WIN%",
    sortingOrder: ["desc", "asc", null],
    field: "",
    minWidth: 50,
    maxWidth: 50,
    wrapText: false,
    suppressMenu: true,
    cellRenderer: (data) => {
      return `${Math.round(
        (data.data._source.totalWins * 100) / data.data._source.totalMatches
      )}%`;
    },
    sortable: false,
  },
  {
    headerName: "WINS",
    sortingOrder: ["desc", "asc", null],
    field: "_source.totalWins",
    minWidth: 50,
    maxWidth: 70,
    wrapText: false,
    suppressMenu: true,
    sortable: true,
  },
  {
    headerName: "MATCHES",
    sortingOrder: ["desc", "asc", null],
    field: "_source.totalMatches",
    minWidth: 70,
    maxWidth: 70,
    wrapText: false,
    suppressMenu: true,
    sortable: true,
  },
]);
export const rankingsStatePprColDefs = enhanceRankingsColumnDefs([
  {
    headerName: "#",
    sortingOrder: ["desc", "asc", null],
    field: "_source.stateRank",
    minWidth: 50,
    maxWidth: 70,
    pinned: "left",
    wrapText: false,
    suppressMenu: true,
    sortable: true,
  },
  {
    headerName: "Name",
    sortingOrder: ["desc", "asc", null],
    field: "_source.displayName",
    minWidth: 90,
    sortable: true,
    wrapText: true,
    suppressMenu: true,
    pinned: "left",
    filter: "agTextColumnFilter",
    filterParams: {
      debounceMs: 200,
      suppressAndOrCondition: true,
      filterOptions: ["contains"],
    },
  },
  {
    headerName: "Club",
    sortingOrder: ["desc", "asc", null],
    field: "_source.clubName",
    minWidth: 90,
    sortable: true,
    wrapText: true,
    suppressMenu: true,
    filter: "agTextColumnFilter",
    filterParams: {
      debounceMs: 200,
      suppressAndOrCondition: true,
      filterOptions: ["contains"],
    },
  },
  {
    headerName: "ST",
    sortingOrder: ["desc", "asc", null],
    field: "_source.state",
    minWidth: 35,
    maxWidth: 35,
    wrapText: false,
    sortable: true,
    suppressMenu: true,
    filter: "agTextColumnFilter",
    filterParams: {
      debounceMs: 200,
      suppressAndOrCondition: true,
      filterOptions: ["contains"],
    },
  },
  {
    headerName: "SPR",
    sortingOrder: ["desc", "asc", null],
    field: "_source.currentRanking",
    minWidth: 50,
    maxWidth: 65,
    wrapText: false,
    suppressMenu: true,
    cellRenderer: (data) => {
      return Number(data.value).toFixed(2);
    },
    sortable: true,
    hide: sport === "pickleball",
  },
  {
    headerName: "DUPR SINGLES",
    sortingOrder: ["desc", "asc", null],
    field: "_source.duprSingles",
    minWidth: 65,
    maxWidth: 65,
    wrapText: false,
    suppressMenu: true,
    cellRenderer: (data) => {
      return Number(data.value).toFixed(2);
    },
    sortable: true,
    hide: sport !== "pickleball",
  },
  {
    headerName: "DUPR DOUBLES",
    sortingOrder: ["desc", "asc", null],
    field: "_source.duprDoubles",
    minWidth: 75,
    maxWidth: 75,
    wrapText: false,
    suppressMenu: true,
    cellRenderer: (data) => {
      return Number(data.value).toFixed(2);
    },
    sortable: true,
    hide: sport !== "pickleball",
  },
  {
    headerName: "PPR",
    sortingOrder: ["desc", "asc", null],
    field: "_source.ppr",
    minWidth: 45,
    maxWidth: 60,
    wrapText: false,
    suppressMenu: true,
    cellRenderer: (data) => {
      if (data.value) {
        return Number(data.value).toFixed(2);
      } else {
        return null;
      }
    },
    sortable: true,
  },
  {
    headerName: "DPR",
    sortingOrder: ["desc", "asc", null],
    field: "_source.dpr",
    minWidth: 45,
    maxWidth: 60,
    wrapText: false,
    suppressMenu: true,
    cellRenderer: (data) => {
      if (data.value) {
        return Number(data.value).toFixed(2);
      } else {
        return null;
      }
    },
    sortable: true,
  },
  {
    headerName: "OPPR",
    sortingOrder: ["desc", "asc", null],
    field: "_source.oppr",
    minWidth: 45,
    maxWidth: 60,
    wrapText: false,
    suppressMenu: true,
    cellRenderer: (data) => {
      if (data.value) {
        return Number(data.value).toFixed(2);
      } else {
        return null;
      }
    },
    sortable: true,
  },
  {
    headerName: "SBD",
    sortingOrder: ["desc", "asc", null],
    field: "_source.matchTypeDiff",
    minWidth: 50,
    maxWidth: 50,
    wrapText: false,
    suppressMenu: true,
    sortable: true,
  },
  {
    headerName: "SB%",
    sortingOrder: ["desc", "asc", null],
    field: "_source.matchTypeDiffPercent",
    minWidth: 50,
    maxWidth: 50,
    wrapText: false,
    suppressMenu: true,
    cellRenderer: (data) => {
      // console.log("SB% data: ", data);
      return data.value !== null && data.value !== undefined
        ? `${data.value}%`
        : "";
    },
    sortable: true,
  },
  {
    headerName: "WIN%",
    sortingOrder: ["desc", "asc", null],
    field: "",
    minWidth: 50,
    maxWidth: 50,
    wrapText: false,
    suppressMenu: true,
    cellRenderer: (data) => {
      return `${Math.round(
        (data.data._source.totalWins * 100) / data.data._source.totalMatches
      )}%`;
    },
    sortable: false,
  },
  {
    headerName: "WINS",
    sortingOrder: ["desc", "asc", null],
    field: "_source.totalWins",
    minWidth: 50,
    maxWidth: 70,
    wrapText: false,
    suppressMenu: true,
    sortable: true,
  },
  {
    headerName: "MATCHES",
    sortingOrder: ["desc", "asc", null],
    field: "_source.totalMatches",
    minWidth: 70,
    maxWidth: 70,
    wrapText: false,
    suppressMenu: true,
    sortable: true,
  },
  {
    headerName: "4IN%",
    sortingOrder: ["desc", "asc", null],
    field: "_source.totalfourinpercent",
    minWidth: 45,
    maxWidth: 60,
    wrapText: false,
    suppressMenu: true,
    sortable: true,
  },
  {
    headerName: "IN%",
    sortingOrder: ["desc", "asc", null],
    field: "_source.totalinpercent",
    minWidth: 45,
    maxWidth: 60,
    wrapText: false,
    suppressMenu: true,
    sortable: true,
  },
  {
    headerName: "ON%",
    sortingOrder: ["desc", "asc", null],
    field: "_source.totalonpercent",
    minWidth: 45,
    maxWidth: 60,
    wrapText: false,
    suppressMenu: true,
    sortable: true,
  },
  {
    headerName: "OFF%",
    sortingOrder: ["desc", "asc", null],
    field: "_source.totaloffpercent",
    minWidth: 50,
    maxWidth: 60,
    wrapText: false,
    suppressMenu: true,
    sortable: true,
  },
  {
    headerName: "RND",
    sortingOrder: ["desc", "asc", null],
    field: "_source.totalrounds",
    minWidth: 45,
    maxWidth: 60,
    wrapText: false,
    suppressMenu: true,
    sortable: true,
  },

  {
    headerName: "RW%",
    sortingOrder: ["desc", "asc", null],
    field: "_source.roundwinpercent",
    minWidth: 45,
    maxWidth: 60,
    wrapText: false,
    suppressMenu: true,
    sortable: true,
  },
  {
    headerName: "RL%",
    sortingOrder: ["desc", "asc", null],
    field: "_source.roundlosspercent",
    minWidth: 45,
    maxWidth: 60,
    wrapText: false,
    suppressMenu: true,
    sortable: true,
  },
  {
    headerName: "RT%",
    sortingOrder: ["desc", "asc", null],
    field: "_source.roundtiepercent",
    minWidth: 45,
    maxWidth: 60,
    wrapText: false,
    suppressMenu: true,
    sortable: true,
  },
]);
export const rankingsStateHorseshoesPprColDefs = enhanceRankingsColumnDefs([
  {
    headerName: "#",
    sortingOrder: ["desc", "asc", null],
    field: "_source.stateRank",
    minWidth: 50,
    maxWidth: 70,
    pinned: "left",
    wrapText: false,
    suppressMenu: true,
    sortable: true,
  },
  {
    headerName: "Name",
    sortingOrder: ["desc", "asc", null],
    field: "_source.displayName",
    minWidth: 90,
    sortable: true,
    wrapText: true,
    suppressMenu: true,
    pinned: "left",
    filter: "agTextColumnFilter",
    filterParams: {
      debounceMs: 200,
      suppressAndOrCondition: true,
      filterOptions: ["contains"],
    },
  },
  {
    headerName: "Club",
    sortingOrder: ["desc", "asc", null],
    field: "_source.clubName",
    minWidth: 90,
    sortable: true,
    wrapText: true,
    suppressMenu: true,
    filter: "agTextColumnFilter",
    filterParams: {
      debounceMs: 200,
      suppressAndOrCondition: true,
      filterOptions: ["contains"],
    },
  },
  {
    headerName: "ST",
    sortingOrder: ["desc", "asc", null],
    field: "_source.state",
    minWidth: 35,
    maxWidth: 35,
    wrapText: false,
    sortable: true,
    suppressMenu: true,
    filter: "agTextColumnFilter",
    filterParams: {
      debounceMs: 200,
      suppressAndOrCondition: true,
      filterOptions: ["contains"],
    },
  },
  {
    headerName: "SPR",
    sortingOrder: ["desc", "asc", null],
    field: "_source.currentRanking",
    minWidth: 50,
    maxWidth: 65,
    wrapText: false,
    suppressMenu: true,
    cellRenderer: (data) => {
      return Number(data.value).toFixed(2);
    },
    sortable: true,
    hide: sport === "pickleball",
  },
  {
    headerName: "DUPR SINGLES",
    sortingOrder: ["desc", "asc", null],
    field: "_source.duprSingles",
    minWidth: 65,
    maxWidth: 65,
    wrapText: false,
    suppressMenu: true,
    cellRenderer: (data) => {
      return Number(data.value).toFixed(2);
    },
    sortable: true,
    hide: sport !== "pickleball",
  },
  {
    headerName: "DUPR DOUBLES",
    sortingOrder: ["desc", "asc", null],
    field: "_source.duprDoubles",
    minWidth: 75,
    maxWidth: 75,
    wrapText: false,
    suppressMenu: true,
    cellRenderer: (data) => {
      return Number(data.value).toFixed(2);
    },
    sortable: true,
    hide: sport !== "pickleball",
  },
  {
    headerName: "PPR",
    sortingOrder: ["desc", "asc", null],
    field: "_source.ppr",
    minWidth: 45,
    maxWidth: 60,
    wrapText: false,
    suppressMenu: true,
    cellRenderer: (data) => {
      if (data.value) {
        return Number(data.value).toFixed(2);
      } else {
        return null;
      }
    },
    sortable: true,
  },
  {
    headerName: "DPR",
    sortingOrder: ["desc", "asc", null],
    field: "_source.dpr",
    minWidth: 45,
    maxWidth: 60,
    wrapText: false,
    suppressMenu: true,
    cellRenderer: (data) => {
      if (data.value) {
        return Number(data.value).toFixed(2);
      } else {
        return null;
      }
    },
    sortable: true,
  },
  {
    headerName: "OPPR",
    sortingOrder: ["desc", "asc", null],
    field: "_source.oppr",
    minWidth: 45,
    maxWidth: 60,
    wrapText: false,
    suppressMenu: true,
    cellRenderer: (data) => {
      if (data.value) {
        return Number(data.value).toFixed(2);
      } else {
        return null;
      }
    },
    sortable: true,
  },
  {
    headerName: "SBD",
    sortingOrder: ["desc", "asc", null],
    field: "_source.matchTypeDiff",
    minWidth: 50,
    maxWidth: 50,
    wrapText: false,
    suppressMenu: true,
    sortable: true,
  },
  {
    headerName: "SB%",
    sortingOrder: ["desc", "asc", null],
    field: "_source.matchTypeDiffPercent",
    minWidth: 50,
    maxWidth: 50,
    wrapText: false,
    suppressMenu: true,
    cellRenderer: (data) => {
      // console.log("SB% data: ", data);
      return data.value !== null && data.value !== undefined
        ? `${data.value}%`
        : "";
    },
    sortable: true,
  },
  {
    headerName: "WIN%",
    sortingOrder: ["desc", "asc", null],
    field: "",
    minWidth: 50,
    maxWidth: 50,
    wrapText: false,
    suppressMenu: true,
    cellRenderer: (data) => {
      return `${Math.round(
        (data.data._source.totalWins * 100) / data.data._source.totalMatches
      )}%`;
    },
    sortable: false,
  },
  {
    headerName: "WINS",
    sortingOrder: ["desc", "asc", null],
    field: "_source.totalWins",
    minWidth: 50,
    maxWidth: 70,
    wrapText: false,
    suppressMenu: true,
    sortable: true,
  },
  {
    headerName: "MATCHES",
    sortingOrder: ["desc", "asc", null],
    field: "_source.totalMatches",
    minWidth: 70,
    maxWidth: 70,
    wrapText: false,
    suppressMenu: true,
    sortable: true,
  },
  {
    headerName: "2-R%",
    sortingOrder: ["desc", "asc", null],
    field: "_source.totalring2percent",
    minWidth: 45,
    maxWidth: 60,
    wrapText: false,
    suppressMenu: true,
    sortable: true,
  },
  {
    headerName: "1-R%",
    sortingOrder: ["desc", "asc", null],
    field: "_source.totalring1percent",
    minWidth: 45,
    maxWidth: 60,
    wrapText: false,
    suppressMenu: true,
    sortable: true,
  },
  {
    headerName: "0-R%",
    sortingOrder: ["desc", "asc", null],
    field: "_source.totalring0percent",
    minWidth: 45,
    maxWidth: 60,
    wrapText: false,
    suppressMenu: true,
    sortable: true,
  },
  {
    headerName: "TR%",
    sortingOrder: ["desc", "asc", null],
    field: "_source.totalallinpercent",
    minWidth: 50,
    maxWidth: 60,
    wrapText: false,
    suppressMenu: true,
    sortable: true,
  },
  {
    headerName: "MISS%",
    sortingOrder: ["desc", "asc", null],
    field: "_source.totaloffpercent",
    minWidth: 50,
    maxWidth: 60,
    wrapText: false,
    suppressMenu: true,
    sortable: true,
  },
  {
    headerName: "RND",
    sortingOrder: ["desc", "asc", null],
    field: "_source.totalrounds",
    minWidth: 45,
    maxWidth: 60,
    wrapText: false,
    suppressMenu: true,
    sortable: true,
  },

  {
    headerName: "RW%",
    sortingOrder: ["desc", "asc", null],
    field: "_source.roundwinpercent",
    minWidth: 45,
    maxWidth: 60,
    wrapText: false,
    suppressMenu: true,
    sortable: true,
  },
  {
    headerName: "RL%",
    sortingOrder: ["desc", "asc", null],
    field: "_source.roundlosspercent",
    minWidth: 45,
    maxWidth: 60,
    wrapText: false,
    suppressMenu: true,
    sortable: true,
  },
  {
    headerName: "RT%",
    sortingOrder: ["desc", "asc", null],
    field: "_source.roundtiepercent",
    minWidth: 45,
    maxWidth: 60,
    wrapText: false,
    suppressMenu: true,
    sortable: true,
  },
]);
export const testGridFilterDefs = enhanceRankingsColumnDefs([
  {
    headerName: "#",
    sortingOrder: ["desc", "asc", null],
    field: "globalRank",
    minWidth: 50,
    maxWidth: 70,
    pinned: "left",
    wrapText: false,
    // suppressMenu: true,
    sortable: true,
  },
  {
    headerName: "Name",
    sortingOrder: ["desc", "asc", null],
    field: "displayName",
    minWidth: 90,
    sortable: true,
    wrapText: true,
    // suppressMenu: true,
    pinned: "left",
    filter: "agTextColumnFilter",
    filterParams: {
      debounceMs: 200,
      suppressAndOrCondition: true,
      filterOptions: ["contains"],
    },
  },
  {
    headerName: "SPR",
    sortingOrder: ["desc", "asc", null],
    field: "currentRanking",
    minWidth: 45,
    maxWidth: 60,
    wrapText: false,
    // suppressMenu: true,
    filter: "agNumberColumnFilter",
    cellRenderer: (data) => {
      return Number(data.value).toFixed(2);
    },
    sortable: true,
    hide: sport === "pickleball",
  },
  {
    headerName: "DUPR SINGLES",
    sortingOrder: ["desc", "asc", null],
    field: "_source.duprSingles",
    minWidth: 65,
    maxWidth: 65,
    wrapText: false,
    suppressMenu: true,
    cellRenderer: (data) => {
      return Number(data.value).toFixed(2);
    },
    sortable: true,
    hide: sport !== "pickleball",
  },
  {
    headerName: "DUPR DOUBLES",
    sortingOrder: ["desc", "asc", null],
    field: "_source.duprDoubles",
    minWidth: 75,
    maxWidth: 75,
    wrapText: false,
    suppressMenu: true,
    cellRenderer: (data) => {
      return Number(data.value).toFixed(2);
    },
    sortable: true,
    hide: sport !== "pickleball",
  },
]);

export const rankingsClubColDefs = enhanceRankingsColumnDefs([
  {
    headerName: "#",
    sortingOrder: ["desc", "asc", null],
    field: "_source.clubRank",
    maxWidth: 70,
    wrapText: false,
    suppressMenu: true,
    sortable: true,
  },
  {
    headerName: "Name",
    sortingOrder: ["desc", "asc", null],
    field: "_source.displayName",
    minWidth: 120,
    sortable: true,
    wrapText: true,
    suppressMenu: true,
    filter: "agTextColumnFilter",
    filterParams: {
      debounceMs: 200,
      suppressAndOrCondition: true,
      filterOptions: ["contains"],
    },
  },
  {
    headerName: "ST",
    sortingOrder: ["desc", "asc", null],
    field: "_source.state",
    minWidth: 35,
    maxWidth: 35,
    wrapText: false,
    sortable: true,
    suppressMenu: true,
    filter: "agTextColumnFilter",
    filterParams: {
      debounceMs: 200,
      suppressAndOrCondition: true,
      filterOptions: ["contains"],
    },
  },
  {
    headerName: "SPR",
    sortingOrder: ["desc", "asc", null],
    field: "_source.currentRanking",
    minWidth: 50,
    maxWidth: 65,
    wrapText: false,
    suppressMenu: true,
    cellRenderer: (data) => {
      return Number(data.value).toFixed(2);
    },
    sortable: true,
    hide: sport === "pickleball",
  },
  {
    headerName: "DUPR SINGLES",
    sortingOrder: ["desc", "asc", null],
    field: "_source.duprSingles",
    minWidth: 65,
    maxWidth: 65,
    wrapText: false,
    suppressMenu: true,
    cellRenderer: (data) => {
      return Number(data.value).toFixed(2);
    },
    sortable: true,
    hide: sport !== "pickleball",
  },
  {
    headerName: "DUPR DOUBLES",
    sortingOrder: ["desc", "asc", null],
    field: "_source.duprDoubles",
    minWidth: 75,
    maxWidth: 75,
    wrapText: false,
    suppressMenu: true,
    cellRenderer: (data) => {
      return Number(data.value).toFixed(2);
    },
    sortable: true,
    hide: sport !== "pickleball",
  },
  {
    headerName: "WIN%",
    sortingOrder: ["desc", "asc", null],
    field: "",
    minWidth: 50,
    maxWidth: 50,
    wrapText: false,
    suppressMenu: true,
    cellRenderer: (data) => {
      return `${Math.round(
        (data.data._source.totalWins * 100) / data.data._source.totalMatches
      )}%`;
    },
    sortable: false,
  },
  {
    headerName: "WINS",
    sortingOrder: ["desc", "asc", null],
    field: "_source.totalWins",
    minWidth: 50,
    maxWidth: 70,
    wrapText: false,
    suppressMenu: true,
    sortable: true,
  },
  {
    headerName: "MATCHES",
    sortingOrder: ["desc", "asc", null],
    field: "_source.totalMatches",
    minWidth: 70,
    maxWidth: 70,
    wrapText: false,
    suppressMenu: true,
    sortable: true,
  },
]);
export const rankingsClubPprColDefs = enhanceRankingsColumnDefs([
  {
    headerName: "#",
    sortingOrder: ["desc", "asc", null],
    field: "_source.clubRank",
    minWidth: 30,
    maxWidth: 50,
    pinned: "left",
    wrapText: false,
    suppressMenu: true,
    sortable: true,
  },
  {
    headerName: "Name",
    sortingOrder: ["desc", "asc", null],
    field: "_source.displayName",
    minWidth: 120,
    pinned: "left",
    sortable: true,
    wrapText: true,
    suppressMenu: true,
    filter: "agTextColumnFilter",
    filterParams: {
      debounceMs: 200,
      suppressAndOrCondition: true,
      filterOptions: ["contains"],
    },
  },
  {
    headerName: "ST",
    sortingOrder: ["desc", "asc", null],
    field: "_source.state",
    minWidth: 35,
    maxWidth: 35,
    wrapText: false,
    sortable: true,
    suppressMenu: true,
    filter: "agTextColumnFilter",
    filterParams: {
      debounceMs: 200,
      suppressAndOrCondition: true,
      filterOptions: ["contains"],
    },
  },
  {
    headerName: "SPR",
    sortingOrder: ["desc", "asc", null],
    field: "_source.currentRanking",
    minWidth: 50,
    maxWidth: 65,
    wrapText: false,
    suppressMenu: true,
    cellRenderer: (data) => {
      return Number(data.value).toFixed(2);
    },
    sortable: true,
    hide: sport === "pickleball",
  },
  {
    headerName: "DUPR SINGLES",
    sortingOrder: ["desc", "asc", null],
    field: "_source.duprSingles",
    minWidth: 65,
    maxWidth: 65,
    wrapText: false,
    suppressMenu: true,
    cellRenderer: (data) => {
      return Number(data.value).toFixed(2);
    },
    sortable: true,
    hide: sport !== "pickleball",
  },
  {
    headerName: "DUPR DOUBLES",
    sortingOrder: ["desc", "asc", null],
    field: "_source.duprDoubles",
    minWidth: 75,
    maxWidth: 75,
    wrapText: false,
    suppressMenu: true,
    cellRenderer: (data) => {
      return Number(data.value).toFixed(2);
    },
    sortable: true,
    hide: sport !== "pickleball",
  },
  {
    headerName: "PPR",
    sortingOrder: ["desc", "asc", null],
    field: "_source.ppr",
    minWidth: 45,
    maxWidth: 60,
    wrapText: false,
    suppressMenu: true,
    cellRenderer: (data) => {
      if (data.value) {
        return Number(data.value).toFixed(2);
      } else {
        return null;
      }
    },
    sortable: true,
  },
  {
    headerName: "DPR",
    sortingOrder: ["desc", "asc", null],
    field: "_source.dpr",
    minWidth: 45,
    maxWidth: 60,
    wrapText: false,
    suppressMenu: true,
    cellRenderer: (data) => {
      if (data.value) {
        return Number(data.value).toFixed(2);
      } else {
        return null;
      }
    },
    sortable: true,
  },
  {
    headerName: "OPPR",
    sortingOrder: ["desc", "asc", null],
    field: "_source.oppr",
    minWidth: 45,
    maxWidth: 60,
    wrapText: false,
    suppressMenu: true,
    cellRenderer: (data) => {
      if (data.value) {
        return Number(data.value).toFixed(2);
      } else {
        return null;
      }
    },
    sortable: true,
  },
  {
    headerName: "SBD",
    sortingOrder: ["desc", "asc", null],
    field: "_source.matchTypeDiff",
    minWidth: 50,
    maxWidth: 50,
    wrapText: false,
    suppressMenu: true,
    sortable: true,
  },
  {
    headerName: "SB%",
    sortingOrder: ["desc", "asc", null],
    field: "_source.matchTypeDiffPercent",
    minWidth: 50,
    maxWidth: 50,
    wrapText: false,
    suppressMenu: true,
    cellRenderer: (data) => {
      // console.log("SB% data: ", data);
      return data.value !== null && data.value !== undefined
        ? `${data.value}%`
        : "";
    },
    sortable: true,
  },
  {
    headerName: "WIN%",
    sortingOrder: ["desc", "asc", null],
    field: "",
    minWidth: 50,
    maxWidth: 50,
    wrapText: false,
    suppressMenu: true,
    cellRenderer: (data) => {
      return `${Math.round(
        (data.data._source.totalWins * 100) / data.data._source.totalMatches
      )}%`;
    },
    sortable: false,
  },
  {
    headerName: "WINS",
    sortingOrder: ["desc", "asc", null],
    field: "_source.totalWins",
    minWidth: 50,
    maxWidth: 70,
    wrapText: false,
    suppressMenu: true,
    sortable: true,
  },
  {
    headerName: "MATCHES",
    sortingOrder: ["desc", "asc", null],
    field: "_source.totalMatches",
    minWidth: 70,
    maxWidth: 70,
    wrapText: false,
    suppressMenu: true,
    sortable: true,
  },
  {
    headerName: "4IN%",
    sortingOrder: ["desc", "asc", null],
    field: "_source.totalfourinpercent",
    minWidth: 45,
    maxWidth: 60,
    wrapText: false,
    suppressMenu: true,
    sortable: true,
  },
  {
    headerName: "IN%",
    sortingOrder: ["desc", "asc", null],
    field: "_source.totalinpercent",
    minWidth: 45,
    maxWidth: 60,
    wrapText: false,
    suppressMenu: true,
    sortable: true,
  },
  {
    headerName: "ON%",
    sortingOrder: ["desc", "asc", null],
    field: "_source.totalonpercent",
    minWidth: 45,
    maxWidth: 60,
    wrapText: false,
    suppressMenu: true,
    sortable: true,
  },
  {
    headerName: "OFF%",
    sortingOrder: ["desc", "asc", null],
    field: "_source.totaloffpercent",
    minWidth: 50,
    maxWidth: 60,
    wrapText: false,
    suppressMenu: true,
    sortable: true,
  },
  {
    headerName: "RND",
    sortingOrder: ["desc", "asc", null],
    field: "_source.totalrounds",
    minWidth: 45,
    maxWidth: 60,
    wrapText: false,
    suppressMenu: true,
    sortable: true,
  },
  {
    headerName: "RW%",
    sortingOrder: ["desc", "asc", null],
    field: "_source.roundwinpercent",
    minWidth: 45,
    maxWidth: 60,
    wrapText: false,
    suppressMenu: true,
    sortable: true,
  },
  {
    headerName: "RL%",
    sortingOrder: ["desc", "asc", null],
    field: "_source.roundlosspercent",
    minWidth: 45,
    maxWidth: 60,
    wrapText: false,
    suppressMenu: true,
    sortable: true,
  },
  {
    headerName: "RT%",
    sortingOrder: ["desc", "asc", null],
    field: "_source.roundtiepercent",
    minWidth: 45,
    maxWidth: 60,
    wrapText: false,
    suppressMenu: true,
    sortable: true,
  },
]);

export const ghostholioColDefs = enhanceRankingsColumnDefs([
  {
    headerName: "",
    sortingOrder: ["desc", "asc", null],
    colId: "practiceid",
    field: "practiceid",
    hide: true,
    filterParams: {
      applyMiniFilterWhileTyping: true,
    },
    filter: "agSetColumnFilter",
  },
  {
    headerName: "Date",
    sortingOrder: ["desc", "asc", null],
    colId: "gameid",
    field: "gameid",

    sortable: false,
    rowGroup: true,
    hide: true,
    filterParams: {
      applyMiniFilterWhileTyping: true,
    },
    filter: "agSetColumnFilter",
  },
  {
    headerName: "Name",
    sortingOrder: ["desc", "asc", null],
    colId: "playername",
    field: "playername",
    minWidth: 70,
    sortable: false,
    filterParams: {
      applyMiniFilterWhileTyping: true,
    },
    filter: "agSetColumnFilter",
  },
  {
    headerName: "SCR",
    sortingOrder: ["desc", "asc", null],
    colId: "score",
    field: "score",
    minWidth: 60,
    maxWidth: 90,
    sortable: false,
    suppressMenu: true,
    filterParams: {
      applyMiniFilterWhileTyping: true,
    },
    filter: "agSetColumnFilter",
  },
  {
    headerName: "R",
    sortingOrder: ["desc", "asc", null],
    colId: "totalrounds",
    field: "totalrounds",
    minWidth: 30,
    maxWidth: 45,
    sortable: false,
    suppressMenu: true,
    filterParams: {
      applyMiniFilterWhileTyping: true,
    },
    filter: "agSetColumnFilter",
  },
  {
    headerName: "PPR",
    sortingOrder: ["desc", "asc", null],
    colId: "avgpoints",
    field: "avgpoints",
    minWidth: 50,
    maxWidth: 90,
    sortable: false,
    suppressMenu: true,
    filterParams: {
      applyMiniFilterWhileTyping: true,
    },
    filter: "agSetColumnFilter",
    cellRenderer: (data) => {
      return Number(data.value).toFixed(2);
    },
  },
  {
    headerName: "4IN",
    sortingOrder: ["desc", "asc", null],
    colId: "totalfourbagger",
    field: "totalfourbagger",
    minWidth: 30,
    maxWidth: 90,
    sortable: false,
    suppressMenu: true,
    filterParams: {
      applyMiniFilterWhileTyping: true,
    },
    filter: "agSetColumnFilter",
  },
  {
    headerName: "IN",
    sortingOrder: ["desc", "asc", null],
    colId: "totalin",
    field: "totalin",
    minWidth: 30,
    maxWidth: 90,
    sortable: false,
    suppressMenu: true,
    filterParams: {
      applyMiniFilterWhileTyping: true,
    },
    filter: "agSetColumnFilter",
  },
  {
    headerName: "ON",
    sortingOrder: ["desc", "asc", null],
    colId: "totalon",
    field: "totalon",
    minWidth: 30,
    maxWidth: 90,
    sortable: false,
    suppressMenu: true,
    filterParams: {
      applyMiniFilterWhileTyping: true,
    },
    filter: "agSetColumnFilter",
  },
  {
    headerName: "OFF",
    sortingOrder: ["desc", "asc", null],
    field: "totaloff",
    minWidth: 35,
    maxWidth: 60,
    sortable: false,
    suppressMenu: true,
    filterParams: {
      applyMiniFilterWhileTyping: true,
    },
    filter: "agSetColumnFilter",
  },
  {
    headerName: "Bag ID",
    sortingOrder: ["desc", "asc", null],
    colId: "bagId",
    field: "bagId",
    sortable: true,
    suppressMenu: true,
    filterParams: {
      applyMiniFilterWhileTyping: true,
    },
    minWidth: 50,
    filter: "agSetColumnFilter",
    maxWidth: 50,
    hide: true,
  },
  {
    headerName: "Outcome",
    sortingOrder: ["desc", "asc", null],
    colId: "outcome",
    field: "outcome",
    sortable: true,
    suppressMenu: true,
    filterParams: {
      applyMiniFilterWhileTyping: true,
    },
    minWidth: 50,
    filter: "agSetColumnFilter",
    maxWidth: 50,
    hide: true,
  },
  {
    headerName: "Tag",
    sortingOrder: ["desc", "asc", null],
    colId: "tagsStr",
    field: "tagsStr",
    sortable: true,
    suppressMenu: true,
    // filterParams: {
    //   applyMiniFilterWhileTyping: true,
    // },
    minWidth: 50,
    filter: "agMultiColumnFilter",
    //filterType: "multi",

    maxWidth: 50,
    hide: true,
  },
]);

export const decaholioColDefs = enhanceRankingsColumnDefs([
  {
    headerName: "",
    sortingOrder: ["desc", "asc", null],
    field: "practiceid",
    hide: true,
  },
  {
    headerName: "Date",
    sortingOrder: ["desc", "asc", null],
    field: "gameid",
    minWidth: 100,
    sortable: false,
    rowGroup: true,
    hide: true,
  },
  {
    headerName: "Name",
    sortingOrder: ["desc", "asc", null],
    field: "playername",
    minWidth: 80,
    sortable: false,
  },
  {
    headerName: "RD",
    sortingOrder: ["desc", "asc", null],
    colId: "totalrounds",
    field: "totalrounds",
    sortable: true,
    suppressMenu: true,
    filterParams: {
      applyMiniFilterWhileTyping: true,
    },
    minWidth: 35,
    maxWidth: 60,
    filter: "agSetColumnFilter",
    // hide: true,
  },
  {
    headerName: "PPR",
    sortingOrder: ["desc", "asc", null],
    field: "avgpoints",
    minWidth: 60,
    maxWidth: 60,
    sortable: false,
    suppressMenu: true,
    cellRenderer: (data) => {
      return Number(data.value).toFixed(2);
    },
  },
  {
    headerName: "4IN",
    sortingOrder: ["desc", "asc", null],
    field: "totalfourbagger",
    minWidth: 35,
    maxWidth: 45,
    sortable: false,
    suppressMenu: true,
  },
  {
    headerName: "IN",
    sortingOrder: ["desc", "asc", null],
    field: "totalin",
    minWidth: 35,
    maxWidth: 45,
    sortable: false,
    suppressMenu: true,
  },
  {
    headerName: "ON",
    sortingOrder: ["desc", "asc", null],
    field: "totalon",
    minWidth: 35,
    maxWidth: 45,
    sortable: false,
    suppressMenu: true,
  },
  {
    headerName: "OFF",
    sortingOrder: ["desc", "asc", null],
    field: "totaloff",
    minWidth: 35,
    maxWidth: 45,
    sortable: false,
    suppressMenu: true,
  },
  {
    headerName: "Bag ID",
    sortingOrder: ["desc", "asc", null],
    colId: "bagId",
    field: "bagId",
    sortable: true,
    suppressMenu: true,
    filterParams: {
      applyMiniFilterWhileTyping: true,
    },
    minWidth: 50,
    filter: "agSetColumnFilter",
    maxWidth: 50,
    hide: true,
  },
  {
    headerName: "Outcome",
    sortingOrder: ["desc", "asc", null],
    colId: "outcome",
    field: "outcome",
    sortable: true,
    suppressMenu: true,
    filterParams: {
      applyMiniFilterWhileTyping: true,
    },
    minWidth: 50,
    filter: "agSetColumnFilter",
    maxWidth: 50,
    hide: true,
  },
  {
    headerName: "Tag",
    sortingOrder: ["desc", "asc", null],
    colId: "tagsStr",
    field: "tagsStr",
    sortable: true,
    suppressMenu: true,
    // filterParams: {
    //   applyMiniFilterWhileTyping: true,
    // },
    minWidth: 50,
    filter: "agMultiColumnFilter",
    //filterType: "multi",

    maxWidth: 50,
    hide: true,
  },
]);

export const bagTypeDefs = enhanceRankingsColumnDefs([
  {
    headerName: "",
    sortingOrder: ["desc", "asc", null],
    field: "bagId",
    hide: true,
  },
  {
    headerName: "Name",
    sortingOrder: ["desc", "asc", null],
    field: "bagName",
    colId: "bagName",
    minWidth: 80,
    sortable: true,
  },
  {
    headerName: "RD",
    sortingOrder: ["desc", "asc", null],
    colId: "totalRounds",
    field: "totalRounds",
    sortable: true,
    suppressMenu: true,
    filterParams: {
      applyMiniFilterWhileTyping: true,
    },
    minWidth: 35,
    maxWidth: 60,
    filter: "agSetColumnFilter",
    // hide: true,
  },
  {
    headerName: "PPR",
    sortingOrder: ["desc", "asc", null],
    field: "avgPpr",
    colId: "avgPpr",
    minWidth: 60,
    maxWidth: 60,
    sortable: true,
    suppressMenu: true,
    cellRenderer: (data) => {
      return Number(data.value).toFixed(2);
    },
  },
  {
    headerName: "4IN",
    sortingOrder: ["desc", "asc", null],
    field: "totalFourIn",
    colId: "totalFourIn",
    minWidth: 35,
    maxWidth: 45,
    sortable: true,
    suppressMenu: true,
  },
  {
    headerName: "IN",
    sortingOrder: ["desc", "asc", null],
    field: "totalIn",
    colId: "totalIn",
    minWidth: 35,
    maxWidth: 75,
    sortable: true,
    suppressMenu: true,
  },
  {
    headerName: "ON",
    sortingOrder: ["desc", "asc", null],
    field: "totalOn",
    colId: "totalOn",
    minWidth: 35,
    maxWidth: 65,
    sortable: true,
    suppressMenu: true,
  },
  {
    headerName: "OFF",
    sortingOrder: ["desc", "asc", null],
    field: "totalOff",
    colId: "totalOff",
    minWidth: 35,
    maxWidth: 65,
    sortable: true,
    suppressMenu: true,
  },
]);

export const matchHistoryBagTypeDefs = enhanceRankingsColumnDefs([
  {
    headerName: "MATCHES",
    sortingOrder: ["desc", "asc", null],
    colId: "totalMatches",
    field: "totalMatches",
    sortable: true,
    suppressMenu: true,
    filterParams: {
      applyMiniFilterWhileTyping: true,
    },
    minWidth: 60,
    maxWidth: 80,
    filter: "agSetColumnFilter",
    // hide: true,
  },
  {
    headerName: "Name",
    sortingOrder: ["desc", "asc", null],
    field: "bagName",
    colId: "bagName",
    minWidth: 140,
    sortable: true,
    pinned: "left",
    cellRenderer: "agGroupCellRenderer",
  },
  {
    headerName: "",
    sortingOrder: ["desc", "asc", null],
    field: "bagId",
    hide: true,
  },
  {
    headerName: "Rounds",
    sortingOrder: ["desc", "asc", null],
    colId: "totalRounds",
    field: "totalRounds",
    sortable: true,
    suppressMenu: true,
    filterParams: {
      applyMiniFilterWhileTyping: true,
    },
    minWidth: 60,
    // maxWidth: 60,
    filter: "agSetColumnFilter",
    // hide: true,
  },
  {
    headerName: "PPR",
    sortingOrder: ["desc", "asc", null],
    field: "ppr",
    colId: "ppr",
    minWidth: 50,
    maxWidth: 50,
    sortable: true,
    suppressMenu: true,
    cellRenderer: (data) => {
      return Number(data.value).toFixed(2);
    },
  },
  {
    headerName: "OPPR",
    sortingOrder: ["desc", "asc", null],
    field: "oppr",
    colId: "oppr",
    minWidth: 50,
    maxWidth: 50,
    sortable: true,
    suppressMenu: true,
    cellRenderer: (data) => {
      return Number(data.value).toFixed(2);
    },
  },
  {
    headerName: "DPR",
    sortingOrder: ["desc", "asc", null],
    field: "dpr",
    colId: "dpr",
    minWidth: 50,
    maxWidth: 50,
    sortable: true,
    suppressMenu: true,
    cellRenderer: (data) => {
      return Number(data.value).toFixed(2);
    },
  },
  {
    headerName: "4IN",
    sortingOrder: ["desc", "asc", null],
    field: "inFourTotal",
    colId: "inFourTotal",
    minWidth: 35,
    maxWidth: 45,
    sortable: true,
    suppressMenu: true,
  },
  {
    headerName: "4IN%",
    sortingOrder: ["desc", "asc", null],
    field: "inFourPercent",
    colId: "inFourPercent",
    minWidth: 45,
    maxWidth: 45,
    sortable: true,
    suppressMenu: true,
    valueFormatter: (data) => {
      return `${data.value}%`;
    },
  },
  {
    headerName: "IN",
    sortingOrder: ["desc", "asc", null],
    field: "inTotal",
    colId: "inTotal",
    minWidth: 35,
    maxWidth: 45,
    sortable: true,
    suppressMenu: true,
  },
  {
    headerName: "IN%",
    sortingOrder: ["desc", "asc", null],
    field: "inPercent",
    colId: "inPercent",
    minWidth: 45,
    maxWidth: 45,
    sortable: true,
    suppressMenu: true,
    valueFormatter: (data) => {
      return `${data.value}%`;
    },
  },
  {
    headerName: "ON",
    sortingOrder: ["desc", "asc", null],
    field: "onTotal",
    colId: "onTotal",
    minWidth: 35,
    maxWidth: 45,
    sortable: true,
    suppressMenu: true,
  },
  {
    headerName: "ON%",
    sortingOrder: ["desc", "asc", null],
    field: "onPercent",
    colId: "onPercent",
    minWidth: 45,
    maxWidth: 45,
    sortable: true,
    suppressMenu: true,
    valueFormatter: (data) => {
      return `${data.value}%`;
    },
  },
  {
    headerName: "OFF",
    sortingOrder: ["desc", "asc", null],
    field: "offTotal",
    colId: "offTotal",
    minWidth: 35,
    maxWidth: 45,
    sortable: true,
    suppressMenu: true,
  },
  {
    headerName: "OFF%",
    sortingOrder: ["desc", "asc", null],
    field: "offPercent",
    colId: "offPercent",
    minWidth: 50,
    maxWidth: 50,
    sortable: true,
    suppressMenu: true,
    valueFormatter: (data) => {
      return `${data.value}%`;
    },
  },
  {
    headerName: "Net Score",
    sortingOrder: ["desc", "asc", null],
    colId: "totalNetScore",
    field: "totalNetScore",
    sortable: true,
    suppressMenu: true,
    filterParams: {
      applyMiniFilterWhileTyping: true,
    },
    minWidth: 80,
    maxWidth: 80,
    filter: "agSetColumnFilter",
    // hide: true,
  },
]);
export const matchHistoryTagTypeDefs = enhanceRankingsColumnDefs([
  {
    headerName: "MATCHES",
    sortingOrder: ["desc", "asc", null],
    colId: "totalMatches",
    field: "totalMatches",
    sortable: true,
    suppressMenu: true,
    filterParams: {
      applyMiniFilterWhileTyping: true,
    },
    minWidth: 60,
    maxWidth: 80,
    filter: "agSetColumnFilter",
    // hide: true,
  },
  {
    headerName: "Name",
    sortingOrder: ["desc", "asc", null],
    field: "tag",
    colId: "tag",
    minWidth: 140,
    sortable: true,
    pinned: "left",
    cellRenderer: "agGroupCellRenderer",
  },
  // {
  //   headerName: "",
  //   sortingOrder: ["desc", "asc", null],
  //   field: "bagId",
  //   hide: true,
  // },
  {
    headerName: "Rounds",
    sortingOrder: ["desc", "asc", null],
    colId: "totalRounds",
    field: "totalRounds",
    sortable: true,
    suppressMenu: true,
    filterParams: {
      applyMiniFilterWhileTyping: true,
    },
    minWidth: 60,
    // maxWidth: 60,
    filter: "agSetColumnFilter",
    // hide: true,
  },
  {
    headerName: "PPR",
    sortingOrder: ["desc", "asc", null],
    field: "ppr",
    colId: "ppr",
    minWidth: 50,
    maxWidth: 50,
    sortable: true,
    suppressMenu: true,
    cellRenderer: (data) => {
      return Number(data.value).toFixed(2);
    },
  },
  {
    headerName: "OPPR",
    sortingOrder: ["desc", "asc", null],
    field: "oppr",
    colId: "oppr",
    minWidth: 50,
    maxWidth: 50,
    sortable: true,
    suppressMenu: true,
    cellRenderer: (data) => {
      return Number(data.value).toFixed(2);
    },
  },
  {
    headerName: "DPR",
    sortingOrder: ["desc", "asc", null],
    field: "dpr",
    colId: "dpr",
    minWidth: 50,
    maxWidth: 50,
    sortable: true,
    suppressMenu: true,
    cellRenderer: (data) => {
      return Number(data.value).toFixed(2);
    },
  },
  {
    headerName: "4IN",
    sortingOrder: ["desc", "asc", null],
    field: "inFourTotal",
    colId: "inFourTotal",
    minWidth: 35,
    maxWidth: 45,
    sortable: true,
    suppressMenu: true,
  },
  {
    headerName: "4IN%",
    sortingOrder: ["desc", "asc", null],
    field: "inFourPercent",
    colId: "inFourPercent",
    minWidth: 45,
    maxWidth: 45,
    sortable: true,
    suppressMenu: true,
    valueFormatter: (data) => {
      return `${data.value}%`;
    },
  },
  {
    headerName: "IN",
    sortingOrder: ["desc", "asc", null],
    field: "inTotal",
    colId: "inTotal",
    minWidth: 35,
    maxWidth: 45,
    sortable: true,
    suppressMenu: true,
  },
  {
    headerName: "IN%",
    sortingOrder: ["desc", "asc", null],
    field: "inPercent",
    colId: "inPercent",
    minWidth: 45,
    maxWidth: 45,
    sortable: true,
    suppressMenu: true,
    valueFormatter: (data) => {
      return `${data.value}%`;
    },
  },
  {
    headerName: "ON",
    sortingOrder: ["desc", "asc", null],
    field: "onTotal",
    colId: "onTotal",
    minWidth: 35,
    maxWidth: 45,
    sortable: true,
    suppressMenu: true,
  },
  {
    headerName: "ON%",
    sortingOrder: ["desc", "asc", null],
    field: "onPercent",
    colId: "onPercent",
    minWidth: 45,
    maxWidth: 45,
    sortable: true,
    suppressMenu: true,
    valueFormatter: (data) => {
      return `${data.value}%`;
    },
  },
  {
    headerName: "OFF",
    sortingOrder: ["desc", "asc", null],
    field: "offTotal",
    colId: "offTotal",
    minWidth: 35,
    maxWidth: 45,
    sortable: true,
    suppressMenu: true,
  },
  {
    headerName: "OFF%",
    sortingOrder: ["desc", "asc", null],
    field: "offPercent",
    colId: "offPercent",
    minWidth: 50,
    maxWidth: 50,
    sortable: true,
    suppressMenu: true,
    valueFormatter: (data) => {
      return `${data.value}%`;
    },
  },
  {
    headerName: "Net Score",
    sortingOrder: ["desc", "asc", null],
    colId: "totalNetScore",
    field: "totalNetScore",
    sortable: true,
    suppressMenu: true,
    filterParams: {
      applyMiniFilterWhileTyping: true,
    },
    minWidth: 80,
    maxWidth: 80,
    filter: "agSetColumnFilter",
    // hide: true,
  },
]);

export const matchHistoryBagMasterDetailDefs = enhanceRankingsColumnDefs([
  {
    headerName: "",
    sortingOrder: ["desc", "asc", null],
    field: "bagId",
    hide: true,
  },
  {
    headerName: "Date",
    sortingOrder: ["desc", "asc", null],
    field: "timestamp",
    colId: "timestamp",
    minWidth: 100,
    maxWidth: 100,
    sortable: true,
    suppressMenu: true,
    // cellRenderer: (data) => {
    //   return (
    //     <div
    //       dangerouslySetInnerHTML={{
    //         __html: moment(data.value, "X").format("MMM DD, YYYY[<br/>] h:mma"),
    //       }}
    //     ></div>
    //   );
    // },
    valueFormatter: (data) => {
      return (
        moment(data.value, "X").format("MMM DD, YYYY") +
        "\n" +
        moment(data.value, "X").format("h:mma")
      );
    },
  },
  {
    headerName: "Matchup",
    sortingOrder: ["desc", "asc", null],
    field: "",
    // minWidth: 120,
    maxWidth: 120,
    suppressMenu: true,
    cellRenderer: (data) => {
      // console.log("data.data: ", data.data);
      const win = data.data.teamScore > data.data.opponentScore;
      const tie = data.data.teamScore === data.data.opponentScore;
      return (
        <FlexColumn>
          <Text
            size="1em"
            style={{
              width: "100%",
              whiteSpace: "nowrap",
              textOverflow: "ellipsis",
              // borderBottom: "1px solid #efefef",
              fontWeight: win && !tie && "900",
              overflow: "hidden",
            }}
          >
            {data.data.teamName}
          </Text>
          <Text
            size="1em"
            style={{
              width: "100%",
              whiteSpace: "nowrap",
              textOverflow: "ellipsis",
              fontWeight: !win && !tie && "900",
              overflow: "hidden",
            }}
          >
            {data.data.opponentTeamName}
          </Text>
        </FlexColumn>
      );
    },
  },
  {
    headerName: "Score",
    sortingOrder: ["desc", "asc", null],
    field: "score",
    suppressMenu: true,
    minWidth: 50,
    maxWidth: 50,
    cellRenderer: (data) => {
      const win = data.data.teamScore > data.data.opponentScore;
      const tie = data.data.teamScore === data.data.opponentScore;
      return (
        <FlexColumn align="flex-end">
          <Text
            size="1em"
            style={{
              // width: "100%",
              whiteSpace: "nowrap",
              textOverflow: "ellipsis",
              // borderBottom: "1px solid #efefef",
              fontWeight: win && !tie && "900",
              alignItems: "center",
              alignContent: "center",
            }}
          >
            {data.data.teamScore}
          </Text>
          <Text
            size="1em"
            style={{
              whiteSpace: "nowrap",
              textOverflow: "ellipsis",
              fontWeight: !win && !tie && "900",
            }}
          >
            {data.data.opponentScore}
          </Text>
        </FlexColumn>
      );
    },
  },
  {
    headerName: "Opp Bag",
    sortingOrder: ["desc", "asc", null],
    field: "bagOppName",
    colId: "bagOppName",
    minWidth: 140,
    maxWidth: 140,
    sortable: true,
    suppressMenu: true,
  },
  // {
  //   headerName: "Opp Rank",
  //   sortingOrder: ["desc", "asc", null],
  //   field: "opponentTeamRanking",
  //   colId: "opponentTeamRanking",
  //   minWidth: 70,
  //   maxWidth: 80,
  //   sortable: true,
  //   suppressMenu: true,
  //   cellRenderer: (data) => {
  //     return Number(data.value).toFixed(2);
  //   },
  // },
]);

export const findTournament = enhanceRankingsColumnDefs([
  {
    field: "name",
    colId: "name",
    cellStyle: { "white-space": "normal" },
    sortable: true,
    filter: "agTextColumnFilter",
  },
  {
    field: "orgname",
    colId: "orgname",
    cellStyle: { "white-space": "normal" },
    sortable: true,
    filter: "agTextColumnFilter",
  },
  {
    field: "gameticketprice",
    colId: "gameticketprice",
    cellStyle: { "white-space": "normal" },
    sortable: true,
    filter: "agTextColumnFilter",
  },
  {
    colId: "locationfullname",
    field: "locationfullname",
    cellStyle: { "white-space": "normal" },
    sortable: true,
    filter: "agTextColumnFilter",
  },
  {
    colId: "distance",
    field: "distance",
    cellStyle: { "white-space": "normal" },
    sortable: true,
    filter: "agNumberColumnFilter",
  },
  {
    colId: "boards",
    field: "boards",
    cellStyle: { "white-space": "normal" },
    sortable: true,
    filter: "agNumberColumnFilter",
  },
  {
    colId: "gameregistered",
    field: "gameregistered",
    cellStyle: { "white-space": "normal" },
    sortable: true,
    filter: "agNumberColumnFilter",
  },
  {
    colId: "teamcreate",
    field: "teamcreate",
    cellStyle: { "white-space": "normal" },
    sortable: true,
    filter: "agTextColumnFilter",
  },
  {
    colId: "format",
    field: "format",
    cellStyle: { "white-space": "normal" },
    sortable: true,
    filter: "agTextColumnFilter",
  },
  {
    colId: "date",
    field: "gametime",
    cellStyle: { "white-space": "normal" },
    sortable: true,
    filter: "agTextColumnFilter",
  },
]);
export const organizerManagedDefs = enhanceRankingsColumnDefs([
  {
    field: "name",
    colId: "name",
    cellStyle: { "white-space": "normal" },
    filterParams: {
      applyMiniFilterWhileTyping: true,
    },
    sortable: true,
    filter: "agSetColumnFilter",
  },
  {
    colId: "location",
    field: "locationfullname",
    cellStyle: { "white-space": "normal" },
    filterParams: {
      applyMiniFilterWhileTyping: true,
    },
    sortable: true,
    filter: "agSetColumnFilter",
  },
  {
    colId: "registered",
    field: "gameregistered",
    cellStyle: { "white-space": "normal" },
    filterParams: {
      applyMiniFilterWhileTyping: true,
    },
    sortable: true,
    filter: "agSetColumnFilter",
  },
  {
    colId: "teamCreate",
    field: "teamcreate",
    cellStyle: { "white-space": "normal" },
    filterParams: {
      applyMiniFilterWhileTyping: true,
    },
    sortable: true,
    filter: "agSetColumnFilter",
  },
  {
    colId: "format",
    field: "format",
    cellStyle: { "white-space": "normal" },
    filterParams: {
      applyMiniFilterWhileTyping: true,
    },
    sortable: true,
    filter: "agSetColumnFilter",
  },
  {
    colId: "date",
    field: "gametime",
    cellStyle: { "white-space": "normal" },
    filterParams: {
      applyMiniFilterWhileTyping: true,
    },
    sortable: true,
    filter: "agSetColumnFilter",
  },
]);
export const organizerSeasonsDefs = enhanceRankingsColumnDefs([
  {
    field: "seasonName",
    colId: "seasonName",
    cellStyle: { "white-space": "normal" },
    filterParams: {
      applyMiniFilterWhileTyping: true,
    },
    sortable: true,
    filter: "agSetColumnFilter",
  },
  {
    colId: "seasonStartDate",
    field: "seasonStartDate",
    cellStyle: { "white-space": "normal" },
    filterParams: {
      applyMiniFilterWhileTyping: true,
    },
    sortable: true,
    filter: "agSetColumnFilter",
  },
  {
    colId: "seasonSport",
    field: "seasonSport",
    cellStyle: { "white-space": "normal" },
    filterParams: {
      applyMiniFilterWhileTyping: true,
    },
    sortable: true,
    filter: "agSetColumnFilter",
  },
  {
    colId: "seasonOrganization",
    field: "seasonOrganization",
    cellStyle: { "white-space": "normal" },
    filterParams: {
      applyMiniFilterWhileTyping: true,
    },
    sortable: true,
    filter: "agSetColumnFilter",
  },
  {
    colId: "seasonVisibility",
    field: "seasonVisibility",
    cellStyle: { "white-space": "normal" },
    filterParams: {
      applyMiniFilterWhileTyping: true,
    },
    sortable: true,
    filter: "agSetColumnFilter",
  },
  {
    colId: "seasonMembership",
    field: "seasonMembership",
    cellStyle: { "white-space": "normal" },
    filterParams: {
      applyMiniFilterWhileTyping: true,
    },
    sortable: true,
    filter: "agSetColumnFilter",
  },
]);
export const organizerClubColDefs = enhanceRankingsColumnDefs([
  {
    headerName: "#",
    sortingOrder: ["desc", "asc", null],
    field: "_source.clubRank",
    maxWidth: 70,
    wrapText: false,
    suppressMenu: true,
    sortable: true,
  },
  {
    headerName: "Name",
    sortingOrder: ["desc", "asc", null],
    field: "_source.displayName",
    minWidth: 120,
    sortable: true,
    wrapText: true,
    suppressMenu: true,
    filter: "agTextColumnFilter",
    filterParams: {
      debounceMs: 200,
      suppressAndOrCondition: true,
      filterOptions: ["contains"],
    },
  },
  {
    headerName: "ST",
    sortingOrder: ["desc", "asc", null],
    field: "_source.state",
    minWidth: 40,
    maxWidth: 40,
    wrapText: false,
    sortable: true,
    suppressMenu: true,
    filter: "agTextColumnFilter",
    filterParams: {
      debounceMs: 200,
      suppressAndOrCondition: true,
      filterOptions: ["contains"],
    },
  },
  {
    headerName: "SPR",
    sortingOrder: ["desc", "asc", null],
    field: "_source.currentRanking",
    minWidth: 45,
    maxWidth: 60,
    wrapText: false,
    suppressMenu: true,
    cellRenderer: (data) => {
      return Number(data.value).toFixed(2);
    },
    sortable: true,
    hide: sport === "pickleball",
  },
  {
    headerName: "DUPR SINGLES",
    sortingOrder: ["desc", "asc", null],
    field: "_source.duprSingles",
    minWidth: 65,
    maxWidth: 65,
    wrapText: false,
    suppressMenu: true,
    cellRenderer: (data) => {
      return Number(data.value).toFixed(2);
    },
    sortable: true,
    hide: sport !== "pickleball",
  },
  {
    headerName: "DUPR DOUBLES",
    sortingOrder: ["desc", "asc", null],
    field: "_source.duprDoubles",
    minWidth: 75,
    maxWidth: 75,
    wrapText: false,
    suppressMenu: true,
    cellRenderer: (data) => {
      return Number(data.value).toFixed(2);
    },
    sortable: true,
    hide: sport !== "pickleball",
  },
  {
    headerName: "Club",
    sortingOrder: ["desc", "asc", null],
    field: "_source.clubName",
    minWidth: 120,
    maxWidth: 120,
    wrapText: true,
    suppressMenu: true,
    sortable: true,
  },
]);
export const organizerTournamentStatsColDefs = enhanceRankingsColumnDefs([
  {
    headerName: "Tournament",
    sortingOrder: ["desc", "asc", null],
    field: "gameName",
    minWidth: 100,
    pinned: "left",
    sortable: true,
    wrapText: true,
    filter: "agTextColumnFilter",
    filterParams: {
      debounceMs: 200,
      suppressAndOrCondition: true,
      filterOptions: ["contains"],
    },
    cellRenderer: (data) => {
      return (
        <FlexColumn>
          <span>{data.value}</span>
          <Text size=".9em" color={Global.mainFontColorLight}>
            {moment(data.data.gameTime, "X").format("MM/DD/YYYY")}
          </Text>
        </FlexColumn>
      );
    },
  },
  {
    headerName: "Format",
    sortingOrder: ["desc", "asc", null],
    field: "gameFormat",
    minWidth: 80,
    sortable: true,
    wrapText: true,
    filter: "agTextColumnFilter",
    filterParams: {
      debounceMs: 200,
      suppressAndOrCondition: true,
      filterOptions: ["contains"],
    },
  },
  {
    headerName: "Generation",
    sortingOrder: ["desc", "asc", null],
    field: "gameTeamCreate",
    minWidth: 80,
    sortable: true,
    wrapText: true,
    filter: "agTextColumnFilter",
    filterParams: {
      debounceMs: 200,
      suppressAndOrCondition: true,
      filterOptions: ["contains"],
    },
  },
  {
    headerName: "Teams",
    sortingOrder: ["desc", "asc", null],
    field: "gameRegistered",
    minWidth: 60,
    maxWidth: 60,
    wrapText: false,
    sortable: true,
    filter: "agNumberColumnFilter",
    filterParams: {
      debounceMs: 200,
      suppressAndOrCondition: true,
      filterOptions: ["equals", "lessThan", "greaterThan"],
    },
  },
  {
    headerName: "Location",
    sortingOrder: ["desc", "asc", null],
    field: "gameLocation",
    minWidth: 150,
    maxWidth: 150,
    wrapText: true,
    sortable: true,
    filter: "agTextColumnFilter",
    filterParams: {
      debounceMs: 200,
      suppressAndOrCondition: true,
      filterOptions: ["equals", "lessThan", "greaterThan"],
    },
  },
  {
    headerName: "Crts",
    sortingOrder: ["desc", "asc", null],
    field: "gameCourts",
    minWidth: 45,
    maxWidth: 60,
    wrapText: false,
    sortable: true,
    filter: "agNumberColumnFilter",
    filterParams: {
      debounceMs: 200,
      suppressAndOrCondition: true,
      filterOptions: ["equals", "lessThan", "greaterThan"],
    },
  },
  {
    headerName: "Total Time",
    sortingOrder: ["desc", "asc", null],
    field: "totalDuration",
    minWidth: 70,
    maxWidth: 70,
    wrapText: false,
    sortable: true,
    filter: "agNumberColumnFilter",
    filterParams: {
      debounceMs: 200,
      suppressAndOrCondition: true,
      filterOptions: ["equals", "lessThan", "greaterThan"],
    },
    valueGetter: (params) => {
      const durationInSeconds = params.data.hasOwnProperty("totalDuration")
        ? params.data.totalDuration
        : 0;
      const hours = Math.floor(durationInSeconds / 3600);
      const minutes = Math.floor((durationInSeconds % 3600) / 60);
      const seconds = Math.floor(durationInSeconds % 60);

      // Format the duration as "HH:MM:SS"
      return `${hours.toString().padStart(2, "0")}:${minutes
        .toString()
        .padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
    },
  },
  {
    headerName: "Play Avg",
    sortingOrder: ["desc", "asc", null],
    field: "matchDuration",
    minWidth: 70,
    maxWidth: 70,
    wrapText: false,
    sortable: true,
    filter: "agNumberColumnFilter",
    filterParams: {
      debounceMs: 200,
      suppressAndOrCondition: true,
      filterOptions: ["equals", "lessThan", "greaterThan"],
    },
    valueGetter: (params) => {
      const durationInSeconds = params.data.matchDuration;
      const hours = Math.floor(durationInSeconds / 3600);
      const minutes = Math.floor((durationInSeconds % 3600) / 60);
      const seconds = Math.floor(durationInSeconds % 60);

      // Format the duration as "HH:MM:SS"
      return `${hours.toString().padStart(2, "0")}:${minutes
        .toString()
        .padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
    },
  },
  {
    headerName: "Wait Avg",
    sortingOrder: ["desc", "asc", null],
    field: "waitDuration",
    minWidth: 70,
    maxWidth: 70,
    wrapText: false,
    sortable: true,
    filter: "agNumberColumnFilter",
    filterParams: {
      debounceMs: 200,
      suppressAndOrCondition: true,
      filterOptions: ["equals", "lessThan", "greaterThan"],
    },
    valueGetter: (params) => {
      const durationInSeconds = params.data.waitDuration;
      const hours = Math.floor(durationInSeconds / 3600);
      const minutes = Math.floor((durationInSeconds % 3600) / 60);
      const seconds = Math.floor(durationInSeconds % 60);

      // Format the duration as "HH:MM:SS"
      return `${hours.toString().padStart(2, "0")}:${minutes
        .toString()
        .padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
    },
  },
  {
    headerName: "RR Matches",
    sortingOrder: ["desc", "asc", null],
    field: "roundRobinMatches",
    minWidth: 60,
    maxWidth: 60,
    wrapText: false,
    sortable: true,
    filter: "agNumberColumnFilter",
    filterParams: {
      debounceMs: 200,
      suppressAndOrCondition: true,
      filterOptions: ["equals", "lessThan", "greaterThan"],
    },
  },
  {
    headerName: "Bracket Matches",
    sortingOrder: ["desc", "asc", null],
    field: "bracketMatches",
    minWidth: 60,
    maxWidth: 60,
    wrapText: false,
    sortable: true,
    filter: "agNumberColumnFilter",
    filterParams: {
      debounceMs: 200,
      suppressAndOrCondition: true,
      filterOptions: ["equals", "lessThan", "greaterThan"],
    },
  },
  {
    headerName: "PPR",
    sortingOrder: ["desc", "asc", null],
    field: "ppr",
    minWidth: 45,
    maxWidth: 60,
    wrapText: false,
    sortable: true,
    filter: "agNumberColumnFilter",
    filterParams: {
      debounceMs: 200,
      suppressAndOrCondition: true,
      filterOptions: ["equals", "lessThan", "greaterThan"],
    },
    cellRenderer: (data) => {
      if (data.value) {
        return Number(data.value).toFixed(2);
      } else {
        return null;
      }
    },
  },
  {
    headerName: "Frames",
    sortingOrder: ["desc", "asc", null],
    field: "totalFrames",
    minWidth: 60,
    maxWidth: 70,
    wrapText: false,
    sortable: true,
    filter: "agNumberColumnFilter",
    filterParams: {
      debounceMs: 200,
      suppressAndOrCondition: true,
      filterOptions: ["equals", "lessThan", "greaterThan"],
    },
  },
  {
    headerName: "Avg Frames",
    sortingOrder: ["desc", "asc", null],
    field: "averageFrames",
    minWidth: 60,
    maxWidth: 70,
    wrapText: false,
    sortable: true,
    filter: "agNumberColumnFilter",
    filterParams: {
      debounceMs: 200,
      suppressAndOrCondition: true,
      filterOptions: ["equals", "lessThan", "greaterThan"],
    },
  },
  {
    headerName: "Matches",
    sortingOrder: ["desc", "asc", null],
    field: "totalMatches",
    minWidth: 60,
    maxWidth: 70,
    wrapText: false,
    sortable: true,
    filter: "agNumberColumnFilter",
    filterParams: {
      debounceMs: 200,
      suppressAndOrCondition: true,
      filterOptions: ["equals", "lessThan", "greaterThan"],
    },
  },
  {
    headerName: "Points",
    sortingOrder: ["desc", "asc", null],
    field: "totalPoints",
    minWidth: 60,
    maxWidth: 60,
    wrapText: false,
    sortable: true,
    filter: "agNumberColumnFilter",
    filterParams: {
      debounceMs: 200,
      suppressAndOrCondition: true,
      filterOptions: ["equals", "lessThan", "greaterThan"],
    },
  },
  {
    headerName: "SM Matches",
    sortingOrder: ["desc", "asc", null],
    field: "totalScoreMagicGames",
    minWidth: 60,
    maxWidth: 60,
    wrapText: true,
    sortable: true,
    filter: "agNumberColumnFilter",
    filterParams: {
      debounceMs: 200,
      suppressAndOrCondition: true,
      filterOptions: ["equals", "lessThan", "greaterThan"],
    },
  },
]);
export const organizerClubPprColDefs = enhanceRankingsColumnDefs([
  {
    headerName: "Display Name",
    sortingOrder: ["desc", "asc", null],
    field: "_source.displayName",
    minWidth: 100,
    pinned: "left",
    sortable: true,
    wrapText: true,
    suppressMenu: true,
    filter: "agTextColumnFilter",
    filterParams: {
      debounceMs: 200,
      suppressAndOrCondition: true,
      filterOptions: ["contains"],
    },
  },
  {
    headerName: "First Name",
    sortingOrder: ["desc", "asc", null],
    field: "_source.firstName",
    minWidth: 80,
    sortable: true,
    wrapText: true,
    suppressMenu: true,
    filter: "agTextColumnFilter",
    filterParams: {
      debounceMs: 200,
      suppressAndOrCondition: true,
      filterOptions: ["contains"],
    },
  },
  {
    headerName: "Last Name",
    sortingOrder: ["desc", "asc", null],
    field: "_source.lastName",
    minWidth: 80,
    sortable: true,
    wrapText: true,
    suppressMenu: true,
    filter: "agTextColumnFilter",
    filterParams: {
      debounceMs: 200,
      suppressAndOrCondition: true,
      filterOptions: ["contains"],
    },
  },
  {
    headerName: "Email",
    sortingOrder: ["desc", "asc", null],
    field: "_source.email",
    minWidth: 120,
    sortable: true,
    wrapText: true,
    suppressMenu: true,
    filter: "agTextColumnFilter",
    filterParams: {
      debounceMs: 200,
      suppressAndOrCondition: true,
      filterOptions: ["contains"],
    },
  },
  {
    headerName: "ST",
    sortingOrder: ["desc", "asc", null],
    field: "_source.state",
    minWidth: 40,
    maxWidth: 40,
    wrapText: false,
    sortable: true,
    suppressMenu: true,
    filter: "agTextColumnFilter",
    filterParams: {
      debounceMs: 200,
      suppressAndOrCondition: true,
      filterOptions: ["contains"],
    },
  },
  {
    headerName: "SPR",
    sortingOrder: ["desc", "asc", null],
    field: "_source.currentRanking",
    minWidth: 45,
    maxWidth: 60,
    wrapText: false,
    suppressMenu: true,
    cellRenderer: (data) => {
      return Number(data.value).toFixed(2);
    },
    sortable: true,
    hide: sport === "pickleball",
  },
  {
    headerName: "DUPR SINGLES",
    sortingOrder: ["desc", "asc", null],
    field: "_source.duprSingles",
    minWidth: 65,
    maxWidth: 65,
    wrapText: false,
    suppressMenu: true,
    cellRenderer: (data) => {
      return Number(data.value).toFixed(2);
    },
    sortable: true,
    hide: sport !== "pickleball",
  },
  {
    headerName: "DUPR DOUBLES",
    sortingOrder: ["desc", "asc", null],
    field: "_source.duprDoubles",
    minWidth: 75,
    maxWidth: 75,
    wrapText: false,
    suppressMenu: true,
    cellRenderer: (data) => {
      return Number(data.value).toFixed(2);
    },
    sortable: true,
    hide: sport !== "pickleball",
  },
  {
    headerName: "PPR",
    sortingOrder: ["desc", "asc", null],
    field: "_source.ppr",
    minWidth: 45,
    maxWidth: 60,
    wrapText: false,
    suppressMenu: true,
    cellRenderer: (data) => {
      if (data.value) {
        return Number(data.value).toFixed(2);
      } else {
        return null;
      }
    },
    sortable: true,
  },
  {
    headerName: "DPR",
    sortingOrder: ["desc", "asc", null],
    field: "_source.dpr",
    minWidth: 45,
    maxWidth: 60,
    wrapText: false,
    suppressMenu: true,
    cellRenderer: (data) => {
      if (data.value) {
        return Number(data.value).toFixed(2);
      } else {
        return null;
      }
    },
    sortable: true,
  },
  {
    headerName: "OPPR",
    sortingOrder: ["desc", "asc", null],
    field: "_source.oppr",
    minWidth: 45,
    maxWidth: 60,
    wrapText: false,
    suppressMenu: true,
    cellRenderer: (data) => {
      if (data.value) {
        return Number(data.value).toFixed(2);
      } else {
        return null;
      }
    },
    sortable: true,
  },
  {
    headerName: "SBD",
    sortingOrder: ["desc", "asc", null],
    field: "_source.matchTypeDiff",
    minWidth: 50,
    maxWidth: 50,
    wrapText: false,
    suppressMenu: true,
    sortable: true,
  },
  {
    headerName: "SB%",
    sortingOrder: ["desc", "asc", null],
    field: "_source.matchTypeDiffPercent",
    minWidth: 50,
    maxWidth: 50,
    wrapText: false,
    suppressMenu: true,
    cellRenderer: (data) => {
      // console.log("SB% data: ", data);
      return data.value !== null && data.value !== undefined
        ? `${data.value}%`
        : "";
    },
    sortable: true,
  },
  {
    headerName: "WINS",
    sortingOrder: ["desc", "asc", null],
    field: "_source.totalWins",
    minWidth: 50,
    maxWidth: 70,
    wrapText: false,
    suppressMenu: true,
    sortable: true,
  },
  {
    headerName: "MATCHES",
    sortingOrder: ["desc", "asc", null],
    field: "_source.totalMatches",
    minWidth: 70,
    maxWidth: 70,
    wrapText: false,
    suppressMenu: true,
    sortable: true,
  },
  {
    headerName: "4IN%",
    sortingOrder: ["desc", "asc", null],
    field: "_source.totalfourinpercent",
    minWidth: 45,
    maxWidth: 60,
    wrapText: false,
    suppressMenu: true,
    sortable: true,
  },
  {
    headerName: "IN%",
    sortingOrder: ["desc", "asc", null],
    field: "_source.totalinpercent",
    minWidth: 45,
    maxWidth: 60,
    wrapText: false,
    suppressMenu: true,
    sortable: true,
  },
  {
    headerName: "ON%",
    sortingOrder: ["desc", "asc", null],
    field: "_source.totalonpercent",
    minWidth: 45,
    maxWidth: 60,
    wrapText: false,
    suppressMenu: true,
    sortable: true,
  },
  {
    headerName: "OFF%",
    sortingOrder: ["desc", "asc", null],
    field: "_source.totaloffpercent",
    minWidth: 50,
    maxWidth: 60,
    wrapText: false,
    suppressMenu: true,
    sortable: true,
  },
  {
    headerName: "RND",
    sortingOrder: ["desc", "asc", null],
    field: "_source.totalrounds",
    minWidth: 45,
    maxWidth: 60,
    wrapText: false,
    suppressMenu: true,
    sortable: true,
  },
  {
    headerName: "Club",
    sortingOrder: ["desc", "asc", null],
    field: "_source.clubName",
    minWidth: 120,
    maxWidth: 120,
    wrapText: true,
    suppressMenu: true,
    sortable: true,
  },
  {
    headerName: "Club Rank",
    sortingOrder: ["desc", "asc", null],
    field: "_source.clubRank",
    minWidth: 70,
    maxWidth: 70,
    wrapText: false,
    suppressMenu: true,
    sortable: true,
  },
  {
    headerName: "Global Rank",
    sortingOrder: ["desc", "asc", null],
    field: "_source.globalRank",
    minWidth: 90,
    maxWidth: 120,
    wrapText: false,
    suppressMenu: true,
    sortable: true,
  },
]);
